(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-concept-v13"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-request-panel')) {
    customElements.define('pw-request-panel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const sticky = this.querySelector('[data-request-sticky]');
        if (!sticky) return;
        const jump = this.querySelector('[data-request-jump]');
        const target = this.querySelector('[data-request-primary]') || this.querySelector('.pc-request__contact');
        const update = () => {
          this.frame = null;
          sticky.hidden = !target || target.getBoundingClientRect().bottom >= 100;
        };
        const schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        jump.addEventListener('click', event => {
          event.preventDefault();
          if (target?.tagName === 'SUMMARY') target.parentElement.open = true;
          this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          const focusTarget = target?.matches('a, button, summary') ? target : this.querySelector('.pc-request__contact a');
          focusTarget?.focus({ preventScroll: true });
        }, { signal });
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-balk-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-promo-bar')) {
    class PWPromoBar extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.shell = this.closest('.pw-promo-bar-shell');
        this.copyButton = this.querySelector('[data-pw-copy-button]');
        this.copyLabel = this.querySelector('[data-pw-copy-label]');
        this.copyStatus = this.querySelector('[data-pw-copy-status]');
        this.codeValue = this.querySelector('[data-pw-code-value]');
        this.motionToggle = this.querySelector('[data-pw-motion-toggle]');
        this.details = this.querySelector('.pw-promo-bar__details');
        this.detailsSummary = this.details ? this.details.querySelector('summary') : null;
        this.detailsClose = this.querySelector('[data-pw-details-close]');
        this.countdown = this.querySelector('[data-pw-countdown]');
        this.handleCopyClick = this.copyCode.bind(this);
        this.handleMotionClick = this.toggleMotion.bind(this);
        this.handleDetailsClose = () => this.closeDetails(true);
        this.handleDetailsToggle = this.updateDetailsLayer.bind(this);
        this.handleDocumentClick = this.closeDetailsFromOutside.bind(this);
        this.handleDocumentKeydown = this.closeDetailsWithKeyboard.bind(this);
        this.handleFocusOut = this.finishPendingDeactivation.bind(this);
        this.handleVisibilityChange = this.updateDocumentVisibility.bind(this);
        this.handleWindowResize = this.scheduleMarqueeRefresh.bind(this);

        if (this.copyButton) {
          this.copyButton.addEventListener('click', this.handleCopyClick);
        }

        if (this.motionToggle) {
          this.motionToggle.disabled = true;
          this.motionToggle.addEventListener('click', this.handleMotionClick);
        }

        if (this.details) {
          this.details.addEventListener('toggle', this.handleDetailsToggle);

          if (this.detailsClose) {
            this.detailsClose.addEventListener('click', this.handleDetailsClose);
          }

          document.addEventListener('click', this.handleDocumentClick);
          document.addEventListener('keydown', this.handleDocumentKeydown);
          this.updateDetailsLayer();
        }

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.addEventListener('focusout', this.handleFocusOut);
        this.updateDocumentVisibility();
        this.setupSchedule();
        this.setupMarquee();
      }

      disconnectedCallback() {
        if (this.copyButton) {
          this.copyButton.removeEventListener('click', this.handleCopyClick);
        }

        if (this.motionToggle) {
          this.motionToggle.removeEventListener('click', this.handleMotionClick);
        }

        if (this.detailsClose) {
          this.detailsClose.removeEventListener('click', this.handleDetailsClose);
        }

        if (this.details) {
          this.details.removeEventListener('toggle', this.handleDetailsToggle);
        }

        if (this.shell) {
          this.shell.classList.remove('pw-promo-bar-shell--details-open');
        }

        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        this.removeEventListener('focusout', this.handleFocusOut);
        window.removeEventListener('resize', this.handleWindowResize);

        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.reducedMotionQuery && this.handlePresentationChange) {
          if (this.reducedMotionQuery.removeEventListener) {
            this.reducedMotionQuery.removeEventListener('change', this.handlePresentationChange);
          } else {
            this.reducedMotionQuery.removeListener(this.handlePresentationChange);
          }
        }

        if (this.mobileViewportQuery && this.handlePresentationChange) {
          if (this.mobileViewportQuery.removeEventListener) {
            this.mobileViewportQuery.removeEventListener('change', this.handlePresentationChange);
          } else {
            this.mobileViewportQuery.removeListener(this.handlePresentationChange);
          }
        }

        window.clearTimeout(this.scheduleTimer);
        window.clearTimeout(this.copyFeedbackTimer);
        window.clearTimeout(this.copyAnnouncementTimer);
        window.cancelAnimationFrame(this.marqueeFrame);

        if (this.marqueeSource) {
          Array.from(this.marqueeSource.querySelectorAll('[data-pw-fill]')).forEach((node) => node.remove());
        }

        if (this.marqueeClone) {
          this.marqueeClone.replaceChildren();
        }

        this.classList.remove('is-marquee-ready');
        this.isInitialized = false;
      }

      setupSchedule() {
        this.startMilliseconds = Number(this.dataset.startTimestamp) * 1000;
        this.endMilliseconds = Number(this.dataset.endTimestamp) * 1000;
        this.scheduleIsValid = this.dataset.scheduleValid !== 'false';
        this.isDesignMode = this.dataset.designMode === 'true';
        this.showHoursOnly = this.dataset.showHours === 'true';
        this.showSeconds = this.dataset.showSeconds === 'true';

        if (this.countdown && Number.isFinite(this.endMilliseconds) && this.endMilliseconds > 0) {
          this.countdown.dateTime = new Date(this.endMilliseconds).toISOString();
        }

        this.updateSchedule();
        this.scheduleNextUpdate();
      }

      updateSchedule() {
        const now = Date.now();
        const hasStart = Number.isFinite(this.startMilliseconds) && this.startMilliseconds > 0;
        const hasEnd = Number.isFinite(this.endMilliseconds) && this.endMilliseconds > 0;
        const hasStarted = !hasStart || now >= this.startMilliseconds;
        const hasNotEnded = !hasEnd || now < this.endMilliseconds;
        const isActive = this.scheduleIsValid && hasStarted && hasNotEnded;

        if (this.shell && !this.isDesignMode) {
          const wasHidden = this.shell.hidden;

          if (!isActive && this.contains(document.activeElement)) {
            this.pendingDeactivation = true;
          } else {
            this.pendingDeactivation = false;
            this.shell.hidden = !isActive;
          }

          if (isActive && wasHidden) {
            this.scheduleMarqueeRefresh();
          }
        }

        if (!this.countdown || !hasEnd) return;

        const remaining = Math.max(0, this.endMilliseconds - now);
        this.countdown.textContent = this.formatCountdown(remaining);
        this.countdown.setAttribute('aria-label', this.formatAccessibleCountdown(remaining));
      }

      scheduleNextUpdate() {
        window.clearTimeout(this.scheduleTimer);

        const now = Date.now();
        const hasStart = Number.isFinite(this.startMilliseconds) && this.startMilliseconds > 0;
        const hasEnd = Number.isFinite(this.endMilliseconds) && this.endMilliseconds > 0;
        let delay = null;

        if (!this.scheduleIsValid) return;

        if (hasStart && now < this.startMilliseconds && !this.isDesignMode) {
          delay = this.startMilliseconds - now + 50;
        } else if (hasEnd && now < this.endMilliseconds) {
          const remaining = this.endMilliseconds - now;

          if (this.countdown) {
            delay = this.showSeconds
              ? 1000 - (now % 1000) + 25
              : Math.max(250, (remaining % 60000) + 50);
          } else {
            delay = remaining + 50;
          }
        }

        if (delay === null) return;

        const safeDelay = Math.min(Math.max(delay, 50), 2147483000);
        this.scheduleTimer = window.setTimeout(() => {
          this.updateSchedule();
          this.scheduleNextUpdate();
        }, safeDelay);
      }

      finishPendingDeactivation() {
        if (!this.pendingDeactivation || !this.shell) return;

        window.requestAnimationFrame(() => {
          if (this.pendingDeactivation && !this.contains(document.activeElement)) {
            this.pendingDeactivation = false;
            this.shell.hidden = true;
          }
        });
      }

      formatCountdown(milliseconds) {
        const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
        const days = Math.floor(totalSeconds / 86400);
        const totalHours = Math.floor(totalSeconds / 3600);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (value) => String(value).padStart(2, '0');

        if (this.showHoursOnly) {
          if (this.showSeconds) {
            return `${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`;
          }

          return `${totalHours}u ${pad(minutes)}m`;
        }

        if (this.showSeconds) {
          const dayPrefix = days > 0 ? `${days}d ` : '';
          return `${dayPrefix}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        }

        const dayPrefix = days > 0 ? `${days}d ` : '';
        return `${dayPrefix}${pad(hours)}u ${pad(minutes)}m`;
      }

      formatAccessibleCountdown(milliseconds) {
        const totalMinutes = Math.max(0, Math.floor(milliseconds / 60000));
        const days = Math.floor(totalMinutes / 1440);
        const totalHours = Math.floor(totalMinutes / 60);
        const hours = Math.floor((totalMinutes % 1440) / 60);
        const minutes = totalMinutes % 60;

        if (this.showHoursOnly) {
          return `${totalHours} uur en ${minutes} minuten resterend`;
        }

        const parts = [];

        if (days > 0) parts.push(`${days} dagen`);
        if (hours > 0) parts.push(`${hours} uur`);
        parts.push(`${minutes} minuten`);
        return `${parts.join(', ')} resterend`;
      }

      setupMarquee() {
        if (this.dataset.marqueeEnabled !== 'true') return;

        this.marqueeViewport = this.querySelector('[data-pw-marquee-viewport]');
        this.marqueeTrack = this.querySelector('[data-pw-marquee-track]');
        this.marqueeSource = this.querySelector('[data-pw-marquee-source]');
        this.marqueeClone = this.querySelector('[data-pw-marquee-clone]');

        if (!this.marqueeViewport || !this.marqueeTrack || !this.marqueeSource || !this.marqueeClone) return;

        Array.from(this.marqueeSource.querySelectorAll('[data-pw-fill]')).forEach((node) => node.remove());
        this.originalMessages = Array.from(this.marqueeSource.children).filter(
          (message) => !message.hasAttribute('data-pw-fill')
        );
        this.scrollSpeed = Math.max(5, Number(this.dataset.scrollSpeed) || 20);
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileViewportQuery = window.matchMedia('(max-width: 749px)');
        this.handlePresentationChange = this.scheduleMarqueeRefresh.bind(this);

        if (!this.originalMessages.length) return;

        [this.reducedMotionQuery, this.mobileViewportQuery].forEach((query) => {
          if (query.addEventListener) {
            query.addEventListener('change', this.handlePresentationChange);
          } else {
            query.addListener(this.handlePresentationChange);
          }
        });

        this.scheduleMarqueeRefresh();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleMarqueeRefresh());
          this.resizeObserver.observe(this.marqueeViewport);
        } else {
          window.addEventListener('resize', this.handleWindowResize);
        }

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-in-view', entry.isIntersecting);
              });
            },
            { rootMargin: '100px 0px' }
          );
          this.visibilityObserver.observe(this);
        } else {
          this.classList.add('is-in-view');
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.scheduleMarqueeRefresh();
          });
        }
      }

      scheduleMarqueeRefresh() {
        window.cancelAnimationFrame(this.marqueeFrame);
        this.marqueeFrame = window.requestAnimationFrame(() => this.refreshMarquee());
      }

      refreshMarquee() {
        if (!this.marqueeViewport || !this.marqueeSource || !this.marqueeClone || !this.marqueeTrack) return;

        Array.from(this.marqueeSource.querySelectorAll('[data-pw-fill]')).forEach((node) => node.remove());

        if (this.usesStaticPresentation()) {
          this.marqueeClone.replaceChildren();
          this.classList.remove('is-marquee-ready');

          if (this.motionToggle) {
            this.motionToggle.disabled = true;
          }

          return;
        }

        const viewportWidth = this.marqueeViewport.clientWidth;

        if (viewportWidth <= 0) {
          this.marqueeClone.replaceChildren();
          this.classList.remove('is-marquee-ready');

          if (this.motionToggle) {
            this.motionToggle.disabled = true;
          }

          return;
        }

        const targetWidth = viewportWidth + 48;
        const maximumSourceNodes = 160;

        while (
          this.marqueeSource.getBoundingClientRect().width < targetWidth &&
          this.marqueeSource.children.length < maximumSourceNodes
        ) {
          this.originalMessages.forEach((message) => {
            if (this.marqueeSource.children.length >= maximumSourceNodes) return;

            const filler = message.cloneNode(true);
            filler.setAttribute('data-pw-fill', '');
            this.makeCloneInert(filler);
            this.marqueeSource.appendChild(filler);
          });
        }

        const cloneNodes = Array.from(this.marqueeSource.children).map((message) => {
          const clone = message.cloneNode(true);
          this.makeCloneInert(clone);
          return clone;
        });

        this.marqueeClone.replaceChildren(...cloneNodes);
        const sourceWidth = Math.ceil(this.marqueeSource.getBoundingClientRect().width);

        if (sourceWidth <= 0) return;

        this.marqueeTrack.style.setProperty('--pw-marquee-shift', `-${sourceWidth}px`);
        this.marqueeTrack.style.setProperty(
          '--pw-promo-duration',
          `${Math.min(180, Math.max(12, sourceWidth / this.scrollSpeed))}s`
        );
        this.classList.add('is-marquee-ready');

        if (this.motionToggle) {
          this.motionToggle.disabled = false;
        }
      }

      usesStaticPresentation() {
        const prefersReducedMotion = this.reducedMotionQuery && this.reducedMotionQuery.matches;
        const usesStaticMobileLayout =
          this.classList.contains('pw-promo-bar--mobile-static') &&
          this.mobileViewportQuery &&
          this.mobileViewportQuery.matches;

        return prefersReducedMotion || usesStaticMobileLayout;
      }

      makeCloneInert(node) {
        node.setAttribute('aria-hidden', 'true');
        node.removeAttribute('data-shopify-editor-block');
        node.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });
        node.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        node.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
      }

      updateDocumentVisibility() {
        this.classList.toggle('is-document-hidden', document.visibilityState !== 'visible');
      }

      toggleMotion() {
        if (!this.motionToggle) return;

        const isPaused = this.classList.toggle('is-user-paused');
        const label = isPaused
          ? this.motionToggle.dataset.playLabel
          : this.motionToggle.dataset.pauseLabel;

        this.motionToggle.setAttribute('aria-label', label);
      }

      updateDetailsLayer() {
        if (!this.shell || !this.details) return;

        this.shell.classList.toggle('pw-promo-bar-shell--details-open', this.details.open);
      }

      closeDetails(restoreFocus) {
        if (!this.details || !this.details.open) return;

        this.details.open = false;

        if (restoreFocus && this.detailsSummary) {
          this.detailsSummary.focus();
        }
      }

      closeDetailsFromOutside(event) {
        if (!this.details || !this.details.open || this.details.contains(event.target)) return;

        this.closeDetails(false);
      }

      closeDetailsWithKeyboard(event) {
        if (event.key !== 'Escape' || !this.details || !this.details.open) return;

        event.preventDefault();
        this.closeDetails(true);
      }

      async copyCode() {
        if (!this.copyButton) return;

        const code = this.copyButton.dataset.code;

        if (!code) return;

        try {
          await this.writeToClipboard(code);
          this.showCopyFeedback(true, code);
        } catch (error) {
          this.selectVisibleCode();
          this.showCopyFeedback(false, code);
        }
      }

      async writeToClipboard(code) {
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(code);
            return;
          } catch (error) {
          }
        }

        const temporaryField = document.createElement('textarea');
        temporaryField.value = code;
        temporaryField.setAttribute('readonly', '');
        temporaryField.setAttribute('tabindex', '-1');
        temporaryField.style.position = 'fixed';
        temporaryField.style.top = '0';
        temporaryField.style.left = '-9999px';
        temporaryField.style.opacity = '0';
        document.body.appendChild(temporaryField);

        let didCopy = false;

        try {
          try {
            temporaryField.focus({ preventScroll: true });
          } catch (error) {
            temporaryField.focus();
          }

          temporaryField.select();
          temporaryField.setSelectionRange(0, temporaryField.value.length);
          didCopy = document.execCommand('copy');
        } finally {
          temporaryField.remove();
          this.copyButton.focus();
        }

        if (!didCopy) {
          throw new Error('Copy command failed');
        }
      }

      selectVisibleCode() {
        if (!this.codeValue || !window.getSelection) return;

        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.codeValue);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      showCopyFeedback(isSuccess, code) {
        const feedbackText = isSuccess
          ? this.copyButton.dataset.copiedLabel
          : this.copyButton.dataset.errorLabel;

        window.clearTimeout(this.copyFeedbackTimer);
        window.clearTimeout(this.copyAnnouncementTimer);
        this.copyButton.classList.toggle('is-copied', isSuccess);
        this.copyButton.classList.toggle('has-copy-error', !isSuccess);

        if (this.copyLabel) {
          this.copyLabel.textContent = feedbackText;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
          this.copyAnnouncementTimer = window.setTimeout(() => {
            if (this.copyStatus && this.copyStatus.isConnected) {
              this.copyStatus.textContent = `${feedbackText}: ${code}`;
            }
          }, 20);
        }

        this.copyFeedbackTimer = window.setTimeout(() => this.resetCopyFeedback(), 2200);
      }

      resetCopyFeedback() {
        if (!this.copyButton) return;

        this.copyButton.classList.remove('is-copied', 'has-copy-error');

        if (this.copyLabel) {
          this.copyLabel.textContent = this.copyButton.dataset.copyLabel;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
        }
      }
    }

    customElements.define('pw-promo-bar', PWPromoBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-collection-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-collection-promo-v4')) {
    class PWCollectionPromo extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.wrapper = this.closest('.pw-collection-promo-wrap');
        this.copyButton = this.querySelector('[data-pw-copy-button]');
        this.codeValue = this.querySelector('.pw-collection-promo__code-value');
        this.copyLabel = this.querySelector('[data-pw-copy-label]');
        this.copyStatus = this.querySelector('[data-pw-copy-status]');
        this.handleCopyClick = this.copyCode.bind(this);
        this.handleScheduleFocusOut = this.finishPendingScheduleHide.bind(this);

        if (this.copyButton) {
          this.copyButton.addEventListener('click', this.handleCopyClick);
        }

        this.addEventListener('focusout', this.handleScheduleFocusOut);
        this.setupSchedule();
        this.startVisibilityObserver();
      }

      disconnectedCallback() {
        if (this.copyButton) {
          this.copyButton.removeEventListener('click', this.handleCopyClick);
        }

        this.removeEventListener('focusout', this.handleScheduleFocusOut);

        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
        }

        window.clearTimeout(this.feedbackTimer);
        window.clearTimeout(this.announcementTimer);
        window.clearTimeout(this.scheduleTimer);
        this.isInitialized = false;
      }

      setupSchedule() {
        const scheduleStart = this.parseScheduledDateTime(this.dataset.scheduleStart);
        const scheduleEnd = this.parseScheduledDateTime(this.dataset.scheduleEnd);

        this.scheduleStartMilliseconds = scheduleStart.milliseconds;
        this.scheduleEndMilliseconds = scheduleEnd.milliseconds;
        this.scheduleIsValid = scheduleStart.isValid && scheduleEnd.isValid;

        if (
          this.scheduleIsValid &&
          this.scheduleStartMilliseconds > 0 &&
          this.scheduleEndMilliseconds > 0 &&
          this.scheduleEndMilliseconds <= this.scheduleStartMilliseconds
        ) {
          this.scheduleIsValid = false;
        }

        this.updateScheduledVisibility();
        this.scheduleNextBoundary();
      }

      parseScheduledDateTime(rawValue) {
        const value = String(rawValue || '').trim();

        if (!value) {
          return { isValid: true, milliseconds: 0 };
        }

        const amsterdamDateTime = value.match(
          /^(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{1,2}):(\d{2})$/
        );

        if (amsterdamDateTime) {
          const [, day, month, year, hour, minute] = amsterdamDateTime.map(Number);
          return this.convertAmsterdamDateTime({ year, month, day, hour, minute });
        }

        /* Houd reeds opgeslagen ISO 8601-waarden uit oudere versies werkend. */
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) {
          const legacyMilliseconds = Date.parse(value);

          if (Number.isFinite(legacyMilliseconds)) {
            return { isValid: true, milliseconds: legacyMilliseconds };
          }
        }

        return { isValid: false, milliseconds: 0 };
      }

      convertAmsterdamDateTime({ year, month, day, hour, minute }) {
        const requestedAsUtc = Date.UTC(year, month - 1, day, hour, minute);
        const calendarCheck = new Date(requestedAsUtc);
        const hasValidNumbers =
          year >= 2000 &&
          month >= 1 &&
          month <= 12 &&
          day >= 1 &&
          day <= 31 &&
          hour >= 0 &&
          hour <= 23 &&
          minute >= 0 &&
          minute <= 59;
        const isRealDate =
          calendarCheck.getUTCFullYear() === year &&
          calendarCheck.getUTCMonth() === month - 1 &&
          calendarCheck.getUTCDate() === day &&
          calendarCheck.getUTCHours() === hour &&
          calendarCheck.getUTCMinutes() === minute;

        if (!hasValidNumbers || !isRealDate) {
          return { isValid: false, milliseconds: 0 };
        }

        try {
          if (!this.scheduleDateTimeFormatter) {
            this.scheduleDateTimeFormatter = new Intl.DateTimeFormat('en-GB', {
              timeZone: this.dataset.scheduleTimeZone || 'Europe/Amsterdam',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hourCycle: 'h23'
            });
          }

          let amsterdamMilliseconds = requestedAsUtc;

          for (let attempt = 0; attempt < 4; attempt += 1) {
            const parts = this.getAmsterdamDateTimeParts(amsterdamMilliseconds);
            const representedAsUtc = Date.UTC(
              parts.year,
              parts.month - 1,
              parts.day,
              parts.hour,
              parts.minute,
              parts.second
            );
            const correction = requestedAsUtc - representedAsUtc;

            amsterdamMilliseconds += correction;

            if (correction === 0) break;
          }

          const check = this.getAmsterdamDateTimeParts(amsterdamMilliseconds);
          const matchesRequestedTime =
            check.year === year &&
            check.month === month &&
            check.day === day &&
            check.hour === hour &&
            check.minute === minute;

          if (!matchesRequestedTime) {
            return { isValid: false, milliseconds: 0 };
          }

          return { isValid: true, milliseconds: amsterdamMilliseconds };
        } catch (error) {
          return { isValid: false, milliseconds: 0 };
        }
      }

      getAmsterdamDateTimeParts(milliseconds) {
        const values = {};

        this.scheduleDateTimeFormatter.formatToParts(new Date(milliseconds)).forEach((part) => {
          if (part.type !== 'literal') values[part.type] = Number(part.value);
        });

        return values;
      }

      updateScheduledVisibility() {
        if (!this.wrapper) return;

        const now = Date.now();
        const hasStart = Number.isFinite(this.scheduleStartMilliseconds) && this.scheduleStartMilliseconds > 0;
        const hasEnd = Number.isFinite(this.scheduleEndMilliseconds) && this.scheduleEndMilliseconds > 0;
        const hasStarted = !hasStart || now >= this.scheduleStartMilliseconds;
        const hasNotEnded = !hasEnd || now < this.scheduleEndMilliseconds;
        const isActive = this.scheduleIsValid && hasStarted && hasNotEnded;

        if (!isActive && this.contains(document.activeElement)) {
          this.pendingScheduleHide = true;
          return;
        }

        this.pendingScheduleHide = false;
        this.wrapper.hidden = !isActive;
      }

      scheduleNextBoundary() {
        window.clearTimeout(this.scheduleTimer);

        if (!this.scheduleIsValid) return;

        const now = Date.now();
        let nextBoundary = 0;

        if (this.scheduleStartMilliseconds > now) {
          nextBoundary = this.scheduleStartMilliseconds;
        } else if (this.scheduleEndMilliseconds > now) {
          nextBoundary = this.scheduleEndMilliseconds;
        }

        if (nextBoundary <= 0) return;

        const delay = Math.min(Math.max(nextBoundary - now + 50, 50), 2147483000);
        this.scheduleTimer = window.setTimeout(() => {
          this.updateScheduledVisibility();
          this.scheduleNextBoundary();
        }, delay);
      }

      finishPendingScheduleHide() {
        if (!this.pendingScheduleHide || !this.wrapper) return;

        window.requestAnimationFrame(() => {
          if (!this.isConnected || !this.pendingScheduleHide) return;
          if (this.contains(document.activeElement)) return;

          this.pendingScheduleHide = false;
          this.wrapper.hidden = true;
        });
      }

      startVisibilityObserver() {
        if (!this.classList.contains('pw-collection-promo--border-glow')) return;
        if (!this.classList.contains('pw-collection-promo--glow-animated')) return;

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-in-view');
          return;
        }

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-in-view', entry.isIntersecting);
            });
          },
          { rootMargin: '120px 0px' }
        );

        this.visibilityObserver.observe(this);
      }

      async copyCode() {
        const code = this.copyButton.dataset.code;

        if (!code) return;

        try {
          await this.writeToClipboard(code);
          this.showFeedback('success', code);
        } catch (error) {
          this.selectVisibleCode();
          this.showFeedback('error', code);
        }
      }

      selectVisibleCode() {
        if (!this.codeValue || !window.getSelection) return;

        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.codeValue);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      async writeToClipboard(code) {
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(code);
            return;
          } catch (error) {
          }
        }

        const temporaryField = document.createElement('textarea');
        temporaryField.value = code;
        temporaryField.setAttribute('readonly', '');
        temporaryField.setAttribute('tabindex', '-1');
        temporaryField.style.position = 'fixed';
        temporaryField.style.top = '0';
        temporaryField.style.left = '-9999px';
        temporaryField.style.opacity = '0';
        document.body.appendChild(temporaryField);

        let didCopy = false;

        try {
          try {
            temporaryField.focus({ preventScroll: true });
          } catch (error) {
            temporaryField.focus();
          }

          temporaryField.select();
          temporaryField.setSelectionRange(0, temporaryField.value.length);
          didCopy = document.execCommand('copy');
        } finally {
          temporaryField.remove();
          this.copyButton.focus();
        }

        if (!didCopy) {
          throw new Error('Copy command failed');
        }
      }

      showFeedback(state, code) {
        const isSuccess = state === 'success';
        const feedbackText = isSuccess
          ? this.copyButton.dataset.copiedLabel
          : this.copyButton.dataset.errorLabel;

        window.clearTimeout(this.feedbackTimer);
        this.copyButton.classList.toggle('is-copied', isSuccess);
        this.copyButton.classList.toggle('has-copy-error', !isSuccess);

        if (this.copyLabel) {
          this.copyLabel.textContent = feedbackText;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
          window.clearTimeout(this.announcementTimer);
          this.announcementTimer = window.setTimeout(() => {
            if (this.copyStatus && this.copyStatus.isConnected) {
              this.copyStatus.textContent = `${feedbackText}: ${code}`;
            }
          }, 20);
        }

        this.feedbackTimer = window.setTimeout(() => {
          this.resetFeedback();
        }, 2200);
      }

      resetFeedback() {
        if (!this.copyButton) return;

        this.copyButton.classList.remove('is-copied', 'has-copy-error');

        if (this.copyLabel) {
          this.copyLabel.textContent = this.copyButton.dataset.copyLabel;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
        }
      }
    }

    customElements.define('pw-collection-promo-v4', PWCollectionPromo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (!root || root.pwNewsletterVersion === '3.8') return;
    if (root.pwNewsletterCleanup) root.pwNewsletterCleanup();
    var form = root.querySelector('.pw-nl__form');
    var stage = root.querySelector('[data-pw-form-content]');
    var email = root.querySelector('input[name="contact[email]"]');
    var button = root.querySelector('[data-pw-submit]');
    var error = root.querySelector('[data-pw-error]');
    var errorText = root.querySelector('[data-pw-error-message]');
    var entry = root.querySelector('[data-pw-entry]');
    var accepted = root.querySelector('[data-pw-accepted]');
    var member = root.querySelector('[data-pw-member]');
    var privacy = root.querySelector('.pw-nl__privacy');
    var messages = root.querySelector('[data-pw-messages]');
    var announce = root.querySelector('[data-pw-announce]');
    if (!form || !stage || !email || !button || !error || !messages) return;
    var preview = root.getAttribute('data-preview-only') === 'true';
    var isMember = stage.getAttribute('data-state') === 'member';
    var originalTarget = form.getAttribute('target');
    // Submission receipt only: never poll the email opt-in or Klaviyo lists.
    var busy = false, pending = false, disposed = false;
    var timer = 0, replyTimer = 0, resizeTimer = 0, frame = null, attempt = 0;
    var submittedAt = 0;
    var measuredWidth = 0, observer = null;
    root.pwNewsletterVersion = '3.8';

    function text(key) { return messages.getAttribute('data-' + key) || messages.getAttribute('data-error') || ''; }
    function hidden(node, hide) {
      if (hide) { node.setAttribute('hidden', ''); node.setAttribute('aria-hidden', 'true'); }
      else { node.removeAttribute('hidden'); node.removeAttribute('aria-hidden'); }
    }
    // Measure non-interactive copies before the visitor submits. Reserve enough
    // space for every short error and the success text, without a scroll container.
    function measurePanel(panel, withErrors) {
      if (!panel) return 0;
      var copy = panel.cloneNode(true);
      copy.removeAttribute('hidden');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-pw-measuring', '');
      var nodes = copy.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].removeAttribute('id');
        nodes[i].removeAttribute('name');
        nodes[i].removeAttribute('role');
        nodes[i].removeAttribute('aria-live');
        nodes[i].setAttribute('tabindex', '-1');
        if ('disabled' in nodes[i]) nodes[i].disabled = true;
        if (/^(IFRAME|SCRIPT)$/.test(nodes[i].tagName) && nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
      }
      stage.appendChild(copy);
      var height = copy.getBoundingClientRect().height;
      var copyError = copy.querySelector('[data-pw-error]');
      var copyText = copy.querySelector('[data-pw-error-message]');
      if (withErrors && copyError && copyText) {
        copyError.removeAttribute('hidden');
        var keys = ['required', 'invalid', 'error', 'offline', 'timeout'];
        for (var k = 0; k < keys.length; k++) {
          copyText.textContent = text(keys[k]);
          height = Math.max(height, copy.getBoundingClientRect().height);
        }
      }
      stage.removeChild(copy);
      return height;
    }
    function reserveSpace() {
      if (disposed || stage.getBoundingClientRect().width < 1) return;
      measuredWidth = stage.getBoundingClientRect().width;
      var height = isMember ? measurePanel(member, false) : Math.max(measurePanel(entry, true), measurePanel(accepted, false));
      stage.style.height = '';
      stage.removeAttribute('data-locked');
      stage.style.minHeight = Math.ceil(height) + 'px';
    }
    function stopLoading() {
      window.clearTimeout(timer);
      window.clearInterval(replyTimer);
      busy = false;
      form.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      email.readOnly = false;
    }
    function showError(message, keepAwaitingReceipt) {
      // A receipt is final. A late iframe load, offline event or timer cannot undo it.
      if (disposed || stage.getAttribute('data-state') === 'accepted' || isMember) return;
      // A delivery timeout is not a Shopify refusal. A later receipt for this
      // same, unchanged attempt may still replace this field error with success.
      pending = keepAwaitingReceipt === true;
      stopLoading();
      stage.setAttribute('data-state', 'error');
      errorText.textContent = message;
      hidden(error, false);
      // Every failed attempt uses the same field-level presentation.
      email.setAttribute('aria-invalid', 'true');
      email.setAttribute('aria-describedby', privacy.id + ' ' + error.id);
      announce.textContent = '';
    }
    function clearError() {
      if (busy || isMember || stage.getAttribute('data-state') === 'accepted') return;
      // Editing the address invalidates a still outstanding receipt for the old input.
      pending = false;
      hidden(error, true);
      email.removeAttribute('aria-invalid');
      email.setAttribute('aria-describedby', privacy.id);
      stage.setAttribute('data-state', 'idle');
    }
    function focusWithoutScroll(node) {
      var supported = false;
      try {
        var probe = document.createElement('span');
        probe.focus(Object.defineProperty({}, 'preventScroll', { get: function () { supported = true; return true; } }));
        if (supported) node.focus({ preventScroll: true });
      } catch (ignore) {}
    }
    function showAccepted() {
      if (disposed || stage.getAttribute('data-state') === 'accepted') return;
      pending = false;
      stopLoading();
      hidden(error, true);
      hidden(entry, true);
      email.disabled = true;
      button.disabled = true;
      hidden(accepted, false);
      stage.setAttribute('data-state', 'accepted');
      announce.textContent = accepted.querySelector('h2').textContent;
      focusWithoutScroll(accepted);
    }
    // Transport is attached to this form only, before Shopify wraps form.submit.
    // Shopify.captcha.protect + its protected submit method still obtain the token.
    // No direct CAPTCHA calls, Admin API keys, consent polling or extra signup API.
    function installSubmitBridge() {
      if (form.pwNewsletterBridge || !window.XMLHttpRequest || !window.FormData) return;
      var proto = window.HTMLFormElement && window.HTMLFormElement.prototype;
      if (!proto || form.submit !== proto.submit) return;
      var nativeSubmit = form.submit;
      var bridge = function () {
        if (typeof form.pwNewsletterSend === 'function') return form.pwNewsletterSend();
        return nativeSubmit.call(form);
      };
      try {
        form.submit = bridge;
        if (form.submit === bridge) form.pwNewsletterBridge = bridge;
      } catch (notWritable) {}
    }
    installSubmitBridge();
    var useAjax = !!form.pwNewsletterBridge;
    var xhr = null, requestStarted = false;
    var submittedEmail = '';
    var originalSend = form.pwNewsletterSend;
    var returnInput = form.querySelector('input[name="return_to"]');
    var originalReturn = returnInput ? returnInput.value : null;
    var originalReturnDisabled = returnInput ? returnInput.disabled : false;
    var addedReturn = false, receiptNonce = '', receiptPath = '';

    function prepareReceiptReturn() {
      // Use Shopify's supported return_to, rather than requiring the returned
      // page to contain this draft section or Shopify's default URL parameter.
      // This correlation value is NOT a consent token and contains no customer data.
      // Return only this section on the public page, not the shop homepage or
      // an account route. Rendering the entire storefront can lose the preview
      // context, start another redirect or prevent the native iframe from loading.
      // This lightweight GET is performed by Shopify's successful POST redirect;
      // we NEVER request the receipt URL ourselves or put it on the POST URL.
      receiptPath = window.location.pathname || '/';
      var sectionId = root.getAttribute('data-section-id') || 'pw-newsletter';
      var themeId = root.getAttribute('data-theme-id') || '';
      var themeRole = (root.getAttribute('data-theme-role') || '').toLowerCase();
      var receiptQuery = '?section_id=' + encodeURIComponent(sectionId);
      if (themeRole !== 'main' && /^\d+$/.test(themeId)) {
        receiptQuery += '&preview_theme_id=' + encodeURIComponent(themeId);
      }
      receiptNonce = Date.now().toString(36) + '-' + attempt + '-' +
        Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
        addedReturn = true;
      }
      // Only sent in this POST. Never navigate to this address ourselves, never
      // add customer_posted=true, and never infer success from the parent's URL.
      returnInput.disabled = false;
      returnInput.value = receiptPath + receiptQuery + '&pw_nl_receipt=' + encodeURIComponent(receiptNonce);
    }
    function matchesReceiptReturn(address) {
      if (!pending || !receiptNonce || !sameOrigin(address)) return false;
      if (address.pathname !== receiptPath) return false;
      var match = /(?:^|[?&])pw_nl_receipt=([^&]*)(?:&|$)/.exec(address.search || '');
      if (!match) return false;
      try { return decodeURIComponent(match[1]) === receiptNonce; }
      catch (invalidQuery) { return false; }
    }

    function resultDiagnostic(reason, httpStatus) {
      // Readable locally in devtools; no customer address, token or remote logging.
      root.pwNewsletterLastResult = {
        version: '3.8', attempt: attempt, transport: useAjax ? 'xhr' : 'native',
        reason: reason, httpStatus: httpStatus || 0,
        elapsedMs: Math.max(0, Date.now() - submittedAt)
      };
    }
    function parseAddress(address) {
      var link = document.createElement('a');
      link.href = address;
      return link;
    }
    function sameOrigin(address) {
      return address && address.protocol === window.location.protocol && address.host === window.location.host;
    }
    function parseDocument(body) {
      if (!body) return null;
      try {
        // Inert parsing: never insert the returned storefront or execute its scripts.
        return new window.DOMParser().parseFromString(body, 'text/html');
      } catch (unavailable) {
        try {
          var doc = document.implementation.createHTMLDocument('');
          doc.documentElement.innerHTML = body;
          return doc;
        } catch (notSupported) { return null; }
      }
    }
    function visibleReplyNode(node) {
      if (!node || !node.textContent.replace(/\s/g, '')) return false;
      for (var ancestor = node; ancestor && ancestor.nodeType === 1; ancestor = ancestor.parentElement) {
        if (ancestor.hasAttribute('hidden') || ancestor.getAttribute('aria-hidden') === 'true' ||
            ancestor.hasAttribute('data-pw-measuring') || ancestor.tagName === 'TEMPLATE' ||
            (ancestor.style && (ancestor.style.display === 'none' || ancestor.style.visibility === 'hidden'))) return false;
      }
      return true;
    }
    function directReceiptParagraph(replyForm, className) {
      // These paragraphs are emitted ONLY by form.posted_successfully? in the
      // shop's existing sections/footer.liquid and sections/newsletter.liquid.
      // A missing input alone, arbitrary text or our hidden preview is NOT proof.
      if (replyForm.querySelector('input[name="contact[email]"], fieldset')) return false;
      var children = replyForm.children;
      for (var j = 0; j < children.length; j++) {
        var node = children[j];
        if (node.tagName === 'P' && (!className || (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1) &&
            visibleReplyNode(node)) return true;
      }
      return false;
    }
    function receiptFromReply(doc, address) {
      // Inspect only this attempt's returned document; never the parent PDP.
      if (address && /\/challenge\/?$/.test(address.pathname)) return 'challenge';
      if (doc && doc.querySelector('.shopify-challenge__container')) return 'challenge';
      var specific = doc && doc.getElementById(form.id);
      var result = specific && specific.querySelector('[data-server-state]');
      var state = result && result.getAttribute('data-server-state');
      if (state === 'error') return result.getAttribute('data-server-error') === 'email' ? 'invalid' : 'error';
      var receipt = '';
      if (/^(accepted|pending|received)$/.test(state || '')) receipt = 'form-receipt';
      var forms = doc ? doc.querySelectorAll('form') : [];
      for (var i = 0; i < forms.length; i++) {
        var replyForm = forms[i];
        if (!replyForm.querySelector('input[name="form_type"][value="customer"]')) continue;
        var server = replyForm.querySelector('[data-server-state]');
        var serverState = server && server.getAttribute('data-server-state');
        // Check actual customer-form rejections before accepting any receipt.
        if (serverState === 'error') return server.getAttribute('data-server-error') === 'email' ? 'invalid' : 'error';
        if (visibleReplyNode(replyForm.querySelector('.errors, .alert--error'))) return 'error';
        if (/^(accepted|pending|received)$/.test(serverState || '')) receipt = 'form-receipt';
        var legacy = (' ' + replyForm.className + ' ').indexOf(' newsletter-form ') !== -1 && replyForm.querySelector('.promo-success');
        if (visibleReplyNode(legacy)) receipt = 'live-theme-receipt';
        // The live footer and standard newsletter have different IDs and no
        // .promo-success class. Their server-rendered receipt is just a paragraph.
        if (replyForm.id === 'newsletter-footer-block' && directReceiptParagraph(replyForm, '')) receipt = 'native-theme-receipt';
        if (/^newsletter-/.test(replyForm.id || '') &&
            (' ' + replyForm.className + ' ').indexOf(' increased-spacing ') !== -1 &&
            directReceiptParagraph(replyForm, 'text-size--large')) receipt = 'native-theme-receipt';
      }
      if (receipt) return receipt;
      // This exact nonce was sent only in return_to in the POST body. We never
      // fetch it ourselves. A POST success redirect remains a saved submission
      // even if the subsequent section GET is missing or cannot render.
      if (matchesReceiptReturn(address)) return 'saved-request-return';
      if (address && /(?:^|[?&])customer_posted=true(?:&|$)/.test(address.search)) return 'redirect-receipt';
      // A pre-existing member, a generic HTTP 200 or a hidden thank-you panel
      // does not prove that the current visitor's submission has been stored.
      return '';
    }
    function applyReceipt(receipt, status) {
      if (!receipt || !pending || disposed) return false;
      resultDiagnostic(receipt, status);
      if (/^(saved-request-return|form-receipt|redirect-receipt|live-theme-receipt|native-theme-receipt)$/.test(receipt)) showAccepted();
      else showError(text(receipt === 'invalid' ? 'invalid' : 'error'));
      return true;
    }
    function encodedFormBody() {
      // Same encoding and successful controls as the original native Shopify form.
      var pairs = [], fields = form.elements;
      function add(name, value) { pairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(value)); }
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i], type = (field.type || '').toLowerCase();
        if (!field.name || field.disabled || /^(submit|button|reset|image|file)$/.test(type)) continue;
        if (/^(checkbox|radio)$/.test(type) && !field.checked) continue;
        if (field.tagName === 'SELECT' && field.multiple) {
          for (var j = 0; j < field.options.length; j++) if (field.options[j].selected) add(field.name, field.options[j].value);
        } else add(field.name, field.value);
      }
      return pairs.join('&');
    }
    function sendRequest() {
      if (disposed || !pending || requestStarted) return;
      requestStarted = true;
      var id = attempt;
      var endpoint = parseAddress(form.action);
      if (!sameOrigin(endpoint) || !/\/contact\/?$/.test(endpoint.pathname)) {
        resultDiagnostic('invalid-submit-endpoint'); showError(text('error')); return;
      }
      // The protection timer must not expire halfway through an actual POST.
      // From here the request's own timeout applies, starting when it is sent.
      window.clearTimeout(timer);
      try {
        var body = encodedFormBody();
        endpoint.hash = '';
        xhr = new XMLHttpRequest();
        var request = xhr;
        var returnedReceipt = false, returnedStatus = 0;
        request.open('POST', endpoint.href, true);
        request.withCredentials = true;
        request.timeout = 30000;
        request.setRequestHeader('Accept', 'text/html, application/xhtml+xml');
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        function rememberRedirect() {
          if (disposed || !pending || id !== attempt) return;
          try {
            var address = request.responseURL ? parseAddress(request.responseURL) : null;
            if (request.status > 0 && matchesReceiptReturn(address)) {
              returnedReceipt = true;
              returnedStatus = request.status;
            }
          } catch (notReady) {}
        }
        function interrupted(reason) {
          if (disposed || !pending || id !== attempt) return;
          rememberRedirect();
          // Headers already proved Shopify completed the POST and redirected to
          // our unique return. A lost return-page body cannot reverse that receipt.
          if (returnedReceipt) { applyReceipt('saved-request-return', returnedStatus); return; }
          resultDiagnostic(reason); showError(text('timeout'));
        }
        request.onreadystatechange = function () {
          if (request.readyState >= 2) rememberRedirect();
        };
        request.onload = function () {
          if (disposed || !pending || id !== attempt) return;
          rememberRedirect();
          var status = request.status;
          var address = request.responseURL ? parseAddress(request.responseURL) : null;
          if (address && !sameOrigin(address)) {
            interrupted('different-origin-response'); return;
          }
          var doc = parseDocument(request.responseText);
          var receipt = receiptFromReply(doc, address);
          // Real form errors and challenges take precedence. A final GET error
          // after the verified POST redirect, however, is NOT a failed signup.
          if (/^(error|invalid|challenge)$/.test(receipt)) { applyReceipt(receipt, status); return; }
          if (returnedReceipt) { applyReceipt('saved-request-return', returnedStatus); return; }
          if (status >= 200 && status < 300 && applyReceipt(receipt, status)) return;
          resultDiagnostic(status >= 200 && status < 300 ? 'response-without-receipt' : 'http-error', status);
          showError(text(status >= 200 && status < 300 ? 'timeout' : 'error'));
        };
        request.onerror = function () { interrupted('network-error'); };
        request.ontimeout = function () { interrupted('network-timeout'); };
        resultDiagnostic('posting-to-shopify');
        request.send(body);
      } catch (failed) {
        resultDiagnostic('request-unavailable'); showError(text('timeout'));
      }
    }
    if (useAjax) form.pwNewsletterSend = sendRequest;

    function removeFrame() {
      window.clearInterval(replyTimer);
      if (!frame) return;
      frame.removeEventListener('load', onResponse);
      if (frame.parentNode) frame.parentNode.removeChild(frame);
      frame = null;
    }
    function inspectResponse() {
      if (disposed || !pending || !frame || requestStarted) return false;
      try {
        var href = frame.contentWindow.location.href;
        if (!href || href === 'about:blank') return false;
        var address = parseAddress(href);
        if (!sameOrigin(address)) return false;
        var doc = frame.contentDocument || frame.contentWindow.document;
        return applyReceipt(receiptFromReply(doc, address), 0);
      } catch (unreadable) { return false; }
    }
    function onResponse() { inspectResponse(); }
    function prepareTransport() {
      removeFrame();
      if (xhr) { try { xhr.abort(); } catch (ignore) {} }
      attempt += 1;
      requestStarted = false;
      xhr = null;
      prepareReceiptReturn();
      // Safety target for an already protected form inserted by the theme editor,
      // or a browser without XHR/FormData. The PDP never becomes the POST target.
      frame = document.createElement('iframe');
      frame.name = 'pw-nl-response-' + root.getAttribute('data-section-id') + '-' + attempt;
      frame.className = 'pw-nl__response';
      frame.title = 'Shopify formulierantwoord';
      frame.tabIndex = -1;
      frame.setAttribute('hidden', '');
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('scrolling', 'no');
      frame.setAttribute('sandbox', 'allow-forms allow-same-origin');
      frame.style.cssText = 'display:none!important;width:0!important;height:0!important;border:0;';
      frame.addEventListener('load', onResponse);
      root.appendChild(frame);
      form.setAttribute('target', frame.name);
    }
    function offline() { return typeof navigator.onLine === 'boolean' && !navigator.onLine; }
    function validate() {
      email.value = email.value.replace(/^\s+|\s+$/g, '');
      if (typeof email.checkValidity === 'function') return email.checkValidity();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
        showError(text(email.value ? 'invalid' : 'required')); return false;
      }
      return true;
    }
    function begin() {
      if (busy) return false;
      clearError();
      try { prepareTransport(); } catch (unavailable) { showError(text('error')); return false; }
      busy = true;
      pending = true;
      submittedAt = Date.now();
      submittedEmail = email.value;
      resultDiagnostic('preparing-protected-submit');
      stage.setAttribute('data-state', 'loading');
      form.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      email.readOnly = true;
      announce.textContent = button.querySelector('.pw-nl__button-loading').textContent;
      replyTimer = window.setInterval(inspectResponse, 100);
      timer = window.setTimeout(function () {
        if (busy && !disposed && !inspectResponse()) {
          resultDiagnostic(requestStarted ? 'request-timeout' : 'protection-not-ready');
          showError(text('timeout'), !requestStarted);
        }
      }, 35000);
      var id = attempt;
      function protectedSubmit() {
        if (disposed || !pending || id !== attempt) return;
        try {
          // Shopify's wrapped method runs CAPTCHA before calling our transport.
          // Do not call HTMLFormElement.prototype.submit or hcaptcha.execute here.
          form.submit();
        } catch (failed) { resultDiagnostic('protected-submit-failed'); showError(text('error')); }
      }
      try {
        if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
          window.Shopify.captcha.protect(form, protectedSubmit);
        } else protectedSubmit();
      } catch (failed) { resultDiagnostic('protection-unavailable'); showError(text('error')); }
      return true;
    }
    function onInvalid(event) {
      if (event.target !== email) return;
      event.preventDefault();
      showError(text(email.value.replace(/^\s+|\s+$/g, '') ? 'invalid' : 'required'));
    }
    function submitIntent(event) {
      event.preventDefault();
      // Invoke the protected form method explicitly, only once for this attempt.
      event.stopImmediatePropagation();
      if (preview || isMember || busy || stage.getAttribute('data-state') === 'accepted') return;
      if (!validate()) return;
      if (offline()) { showError(text('offline')); return; }
      begin();
    }
    function onClick(event) { submitIntent(event); }
    function onSubmit(event) { submitIntent(event); }
    function onKey(event) { if (busy && (event.key === 'Enter' || event.keyCode === 13)) event.preventDefault(); }
    function onOffline() {
      // A connection event after POST is not evidence that Shopify rejected it.
      // Await the response/error of the request rather than overwrite its result.
      if (busy && !requestStarted && !inspectResponse()) showError(text('offline'));
    }
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (!disposed && Math.abs(stage.getBoundingClientRect().width - measuredWidth) >= 1) reserveSpace();
      }, 100);
    }
    function onPageShow(event) {
      if (event.persisted && busy) { if (!inspectResponse()) showError(text('timeout')); removeFrame(); }
    }
    reserveSpace();
    if (window.ResizeObserver) { observer = new window.ResizeObserver(onResize); observer.observe(stage); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!disposed) reserveSpace(); });
    form.addEventListener('submit', onSubmit, true);
    form.addEventListener('invalid', onInvalid, true);
    form.addEventListener('keydown', onKey, true);
    button.addEventListener('click', onClick);
    email.addEventListener('input', clearError);
    window.addEventListener('offline', onOffline);
    window.addEventListener('resize', onResize);
    window.addEventListener('pageshow', onPageShow);
    root.pwNewsletterCleanup = function () {
      disposed = true;
      pending = false;
      stopLoading();
      window.clearTimeout(resizeTimer);
      if (observer) observer.disconnect();
      removeFrame();
      if (xhr) { try { xhr.abort(); } catch (ignore) {} }
      form.pwNewsletterSend = originalSend;
      if (returnInput) {
        if (addedReturn && returnInput.parentNode) returnInput.parentNode.removeChild(returnInput);
        else { returnInput.value = originalReturn; returnInput.disabled = originalReturnDisabled; }
      }
      if (originalTarget === null) form.removeAttribute('target'); else form.setAttribute('target', originalTarget);
      form.removeEventListener('submit', onSubmit, true);
      form.removeEventListener('invalid', onInvalid, true);
      form.removeEventListener('keydown', onKey, true);
      button.removeEventListener('click', onClick);
      email.removeEventListener('input', clearError);
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('pageshow', onPageShow);
      root.pwNewsletterCleanup = null;
      root.pwNewsletterVersion = null;
    };
  }
  function scan(scope) {
    var roots = (scope || document).querySelectorAll('[data-pw-newsletter]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll('[data-pw-newsletter]');
    for (var i = 0; i < roots.length; i++) if (roots[i].pwNewsletterCleanup) roots[i].pwNewsletterCleanup();
  });
}());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'pw-recent-history-carousel';

    if (customElements.get(elementName)) return;

    class PwRecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.shell = this.querySelector('[data-pw-shell]');
        this.track = this.querySelector('[data-pw-track]');
        this.sentinel = this.querySelector('[data-pw-sentinel]');
        this.navigation = this.querySelector('[data-pw-navigation]');
        this.progress = this.querySelector('[data-pw-progress]');
        this.progressControl = this.querySelector('[data-pw-progress-control]');
        this.progressRail = this.querySelector('[data-pw-progress-rail]');
        this.progressThumb = this.querySelector('[data-pw-progress-thumb]');
        this.previousButton = this.querySelector('[data-pw-previous]');
        this.nextButton = this.querySelector('[data-pw-next]');
        this.currentProduct = this.parseCurrentProduct();
        this.maxProducts = Math.max(1, Number.parseInt(this.dataset.maxProducts || '6', 10));
        this.historyLimit = Math.max(12, this.maxProducts + 2);
        this.ttl = 30 * 24 * 60 * 60 * 1000;
        this.abortController = null;
        this.intersectionObserver = null;
        this.exposureObserver = null;
        this.exposurePublished = false;
        this.exposureId = this.createExposureId();
        this.interactionKeys = new Set();
        this.controlFrame = null;
        this.progressPointer = null;
        this.rtlScrollType = null;
        this.loadToken = 0;

        this.onPreviousClick = () => this.scrollByCard(-1);
        this.onNextClick = () => this.scrollByCard(1);
        this.onTrackScroll = () => this.queueControlUpdate();
        this.onResize = () => this.queueControlUpdate();
        this.onProgressPointerDown = (event) => this.handleProgressPointerDown(event);
        this.onProgressPointerMove = (event) => this.handleProgressPointerMove(event);
        this.onProgressPointerUp = (event) => this.handleProgressPointerEnd(event, true);
        this.onProgressPointerCancel = (event) => this.handleProgressPointerEnd(event, false);
        this.onProgressLostCapture = (event) => this.handleProgressLostCapture(event);
        this.onProgressKeyDown = (event) => this.handleProgressKeyDown(event);
        this.onProgressBlur = () => this.progressControl?.removeAttribute('data-pw-pointer-focus');
        this.onTrackClick = (event) => this.handleTrackClick(event);
        this.onPageShow = (event) => {
          if (event.persisted) this.refresh();
        };

        this.previousButton?.addEventListener('click', this.onPreviousClick);
        this.nextButton?.addEventListener('click', this.onNextClick);
        this.track?.addEventListener('scroll', this.onTrackScroll, { passive: true });
        this.track?.addEventListener('click', this.onTrackClick);
        this.progressControl?.addEventListener('pointerdown', this.onProgressPointerDown);
        this.progressControl?.addEventListener('pointermove', this.onProgressPointerMove);
        this.progressControl?.addEventListener('pointerup', this.onProgressPointerUp);
        this.progressControl?.addEventListener('pointercancel', this.onProgressPointerCancel);
        this.progressControl?.addEventListener('lostpointercapture', this.onProgressLostCapture);
        this.progressControl?.addEventListener('keydown', this.onProgressKeyDown);
        this.progressControl?.addEventListener('blur', this.onProgressBlur);
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('pageshow', this.onPageShow);

        this.refresh();
      }

      disconnectedCallback() {
        this.initialized = false;
        this.stopPendingWork();
        this.previousButton?.removeEventListener('click', this.onPreviousClick);
        this.nextButton?.removeEventListener('click', this.onNextClick);
        this.track?.removeEventListener('scroll', this.onTrackScroll);
        this.track?.removeEventListener('click', this.onTrackClick);
        this.progressControl?.removeEventListener('pointerdown', this.onProgressPointerDown);
        this.progressControl?.removeEventListener('pointermove', this.onProgressPointerMove);
        this.progressControl?.removeEventListener('pointerup', this.onProgressPointerUp);
        this.progressControl?.removeEventListener('pointercancel', this.onProgressPointerCancel);
        this.progressControl?.removeEventListener('lostpointercapture', this.onProgressLostCapture);
        this.progressControl?.removeEventListener('keydown', this.onProgressKeyDown);
        this.progressControl?.removeEventListener('blur', this.onProgressBlur);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pageshow', this.onPageShow);
        this.finishProgressPointer();
        if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
      }

      parseCurrentProduct() {
        const node = this.querySelector('[data-pw-current-product]');
        if (!node) return null;

        try {
          return this.normalizeItem(JSON.parse(node.textContent), Date.now());
        } catch (error) {
          return null;
        }
      }

      createExposureId() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }

        return `pw-rv-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      }

      publishImpactEvent(eventName, eventData = {}) {
        if (!window.Shopify?.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;

        const renderedCards = this.track
          ? this.track.querySelectorAll('[data-pw-live-card], [data-pw-cached-card]').length
          : 0;
        const payload = {
          initiative_id: this.dataset.initiativeId || 'cro-recently-viewed',
          feature_id: this.dataset.featureId || 'recently-viewed-products',
          variant_id: this.dataset.variantId || 'live-v1',
          exposure_id: this.exposureId,
          market: this.dataset.market || 'unknown',
          locale: this.dataset.locale || 'unknown',
          page_type: this.dataset.pageType || 'product',
          product_id: this.currentProduct?.id || '',
          section_id: this.dataset.sectionId || '',
          eligible_item_count: Array.isArray(this.candidates) ? this.candidates.length : 0,
          rendered_item_count: renderedCards,
          eligibility_reason: 'has_previous_products',
          source: 'shopify_theme',
          deployment_version: this.dataset.deploymentVersion || 'impact-pilot-1',
          ...eventData
        };

        try {
          const result = window.Shopify.analytics.publish(`perfectewijn:${eventName}`, payload);
          if (result && typeof result.catch === 'function') result.catch(() => {});
          return true;
        } catch (error) {
          return false;
        }
      }

      publishExposure() {
        if (this.exposurePublished || this.shell?.hidden) return;

        const hasCards = this.track?.querySelector('[data-pw-live-card], [data-pw-cached-card]');
        if (!hasCards) return;

        if (this.publishImpactEvent('initiative_exposure', { exposure_type: 'section_visible' })) {
          this.exposurePublished = true;
          this.exposureObserver?.disconnect();
          this.exposureObserver = null;
        }
      }

      observeExposure() {
        if (this.exposurePublished || !this.shell || this.shell.hidden) return;

        this.exposureObserver?.disconnect();

        if (!('IntersectionObserver' in window)) {
          this.publishExposure();
          return;
        }

        this.exposureObserver = new IntersectionObserver((entries) => {
          const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.25);
          if (visible) this.publishExposure();
        }, { threshold: [0.25] });

        this.exposureObserver.observe(this.shell);
      }

      handleTrackClick(event) {
        const target = event.target instanceof Element ? event.target : event.target?.parentElement;
        const link = target?.closest('.pw-rhg__card');
        if (!link || !this.track?.contains(link)) return;

        const card = link.closest('[data-product-id]');
        const targetProductId = String(card?.dataset.productId || '');
        const interactionKey = `product_click:${targetProductId}`;
        if (!targetProductId || this.interactionKeys.has(interactionKey)) return;

        const cards = Array.from(this.track.querySelectorAll('[data-product-id]:not([hidden])'));
        const position = cards.indexOf(card) + 1;
        if (this.publishImpactEvent('initiative_interaction', {
          interaction_type: 'product_click',
          target_product_id: targetProductId,
          target_position: Math.max(1, position)
        })) {
          this.interactionKeys.add(interactionKey);
        }
      }

      normalizeItem(item, fallbackTime) {
        if (!item || typeof item !== 'object') return null;

        const id = String(item.id || '').trim();
        const handle = typeof item.handle === 'string' ? item.handle.trim() : '';
        const viewedAt = Number.isFinite(Number(item.viewedAt)) ? Number(item.viewedAt) : fallbackTime;
        const title = typeof item.title === 'string' ? item.title.trim().slice(0, 240) : '';
        const url = typeof item.url === 'string' ? item.url.trim().slice(0, 500) : '';
        const secondaryText = typeof item.secondaryText === 'string'
          ? item.secondaryText.trim().slice(0, 120)
          : '';
        const image = item.image && typeof item.image === 'object' && typeof item.image.src === 'string'
          ? {
              src: item.image.src.trim().slice(0, 1000),
              width: Math.max(1, Number.parseInt(item.image.width || '1', 10)),
              height: Math.max(1, Number.parseInt(item.image.height || '1', 10))
            }
          : null;
        const rawPrice = item.price && typeof item.price === 'object' ? item.price : null;
        const currentText = typeof rawPrice?.currentText === 'string'
          ? rawPrice.currentText.trim().slice(0, 60)
          : '';
        const compareText = typeof rawPrice?.compareText === 'string'
          ? rawPrice.compareText.trim().slice(0, 60)
          : '';
        const rawOfferText = typeof rawPrice?.offerText === 'string'
          ? rawPrice.offerText.trim().slice(0, 240)
          : '';
        const stackOfferLabel = this.dataset.stackOfferLabel || '';
        const offerText = stackOfferLabel && rawOfferText.startsWith(`${stackOfferLabel} · `)
          ? stackOfferLabel
          : rawOfferText;
        const price = currentText
          ? {
              currentText,
              compareText,
              offerText,
              unitText: typeof rawPrice.unitText === 'string' ? rawPrice.unitText.trim().slice(0, 40) : '',
              soldOutText: typeof rawPrice.soldOutText === 'string' ? rawPrice.soldOutText.trim().slice(0, 60) : '',
              isDiscount: rawPrice.isDiscount === true,
              isFrom: rawPrice.isFrom === true,
              available: rawPrice.available !== false
            }
          : null;

        if (!id || !handle) return null;

        return {
          snapshotVersion: item.snapshotVersion === 2 ? 2 : item.snapshotVersion === 1 ? 1 : 0,
          id,
          handle,
          viewedAt,
          title,
          url,
          image,
          secondaryText,
          hasSecondaryOverride: item.hasSecondaryOverride === true,
          price
        };
      }

      getStorage() {
        try {
          return this.dataset.storageType === 'session' ? window.sessionStorage : window.localStorage;
        } catch (error) {
          return null;
        }
      }

      readHistory() {
        const storage = this.getStorage();
        if (!storage || !this.dataset.storageKey) return [];

        try {
          const saved = JSON.parse(storage.getItem(this.dataset.storageKey) || '{}');
          const rawItems = Array.isArray(saved.items) ? saved.items : [];
          const cutoff = Date.now() - this.ttl;
          const seen = new Set();

          return rawItems.reduce((items, rawItem) => {
            const item = this.normalizeItem(rawItem, 0);
            if (!item || item.viewedAt < cutoff || seen.has(item.id)) return items;
            seen.add(item.id);
            items.push(item);
            return items;
          }, []).slice(0, this.historyLimit);
        } catch (error) {
          return [];
        }
      }

      writeHistory(items) {
        const storage = this.getStorage();
        if (!storage || !this.dataset.storageKey) return;

        try {
          storage.setItem(this.dataset.storageKey, JSON.stringify({
            updatedAt: Date.now(),
            items: items.slice(0, this.historyLimit)
          }));
        } catch (error) {
        }
      }

      saveCurrentProduct(history) {
        if (!this.currentProduct) return history;

        const current = {
          ...this.currentProduct,
          viewedAt: Date.now()
        };
        const updated = [current, ...history.filter((item) => item.id !== current.id)];
        this.writeHistory(updated);
        return updated;
      }

      refresh() {
        if (!this.shell || !this.track || !this.currentProduct) {
          this.hideSection();
          return;
        }

        this.stopPendingWork();
        this.loadToken += 1;
        this.track.replaceChildren();
        this.track.setAttribute('aria-busy', 'false');
        this.hideSection();

        const history = this.readHistory();
        const previousProducts = history
          .filter((item) => item.id !== this.currentProduct.id)
          .slice(0, this.maxProducts);

        this.saveCurrentProduct(history);

        if (!previousProducts.length) return;

        this.candidates = previousProducts;
        this.observeSection();
      }

      observeSection() {
        if (!('IntersectionObserver' in window)) {
          this.loadCandidates(this.candidates);
          return;
        }

        this.intersectionObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.intersectionObserver?.disconnect();
          this.intersectionObserver = null;
          this.loadCandidates(this.candidates);
        }, { rootMargin: '360px 0px' });

        this.intersectionObserver.observe(this.sentinel || this);
      }

      stopPendingWork() {
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = null;
        this.exposureObserver?.disconnect();
        this.exposureObserver = null;
        this.abortController?.abort();
        this.abortController = null;
      }

      storefrontUrl(value) {
        if (!value) return '';

        try {
          const url = new URL(value, window.location.origin);
          if (url.origin !== window.location.origin) return '';
          return `${url.pathname}${url.search}${url.hash}`;
        } catch (error) {
          return '';
        }
      }

      imageUrl(value) {
        if (!value) return '';

        try {
          const url = new URL(value, window.location.origin);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
          return url.toString();
        } catch (error) {
          return '';
        }
      }

      createCachedCard(product) {
        const productUrl = this.storefrontUrl(product.url);
        if (![1, 2].includes(product.snapshotVersion) || !product.title || !productUrl) return null;

        const item = document.createElement('li');
        item.className = 'pw-rhg__item';
        item.dataset.pwCachedCard = '';
        item.dataset.productId = product.id;

        const link = document.createElement('a');
        link.className = 'pw-rhg__card';
        link.href = productUrl;

        const media = document.createElement('div');
        media.className = 'pw-rhg__media';
        const imageSource = this.imageUrl(product.image?.src);

        if (imageSource) {
          const image = document.createElement('img');
          image.className = 'pw-rhg__image';
          image.src = imageSource;
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.setAttribute('fetchpriority', 'low');
          image.width = product.image.width;
          image.height = product.image.height;
          image.addEventListener('error', () => {
            const placeholder = document.createElement('span');
            placeholder.className = 'pw-rhg__placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            image.replaceWith(placeholder);
          }, { once: true });
          media.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'pw-rhg__placeholder';
          placeholder.setAttribute('aria-hidden', 'true');
          media.append(placeholder);
        }

        const content = document.createElement('div');
        content.className = 'pw-rhg__content';

        const title = document.createElement('h3');
        title.className = 'pw-rhg__title';
        title.textContent = product.title;
        content.append(title);

        const secondary = document.createElement('p');
        secondary.className = 'pw-rhg__secondary';
        secondary.dataset.pwLiveSecondary = '';
        secondary.textContent = product.secondaryText;
        secondary.hidden = !product.secondaryText;
        content.append(secondary);

        const priceIsFresh = Date.now() - product.viewedAt <= 24 * 60 * 60 * 1000;

        if (product.snapshotVersion === 2 && product.price && priceIsFresh) {
          const price = document.createElement('div');
          price.className = 'pw-rhg__price';
          price.dataset.pwLivePrice = '';

          if (product.price.offerText) {
            const offer = document.createElement('span');
            offer.className = 'pw-rhg__offer';
            offer.textContent = product.price.offerText;
            price.append(offer);
          }

          if (!product.price.available) {
            const soldOut = document.createElement('span');
            soldOut.className = 'pw-rhg__sold-out';
            soldOut.textContent = product.price.soldOutText;
            price.append(soldOut);
          }

          const values = document.createElement('div');
          values.className = 'pw-rhg__price-values';

          if (product.price.compareText) {
            const compare = document.createElement('s');
            compare.className = 'pw-rhg__compare-price';
            compare.textContent = product.price.compareText;
            values.append(compare);
          }

          const current = document.createElement('span');
          current.className = product.price.isDiscount
            ? 'pw-rhg__current-price pw-rhg__current-price--discount'
            : 'pw-rhg__current-price';

          if (product.price.isFrom) {
            const fromLabel = document.createElement('span');
            fromLabel.className = 'pw-rhg__from-label';
            fromLabel.dataset.pwFromLabel = '';
            fromLabel.textContent = this.dataset.fromLabel || '';
            current.append(fromLabel);
          }

          current.append(document.createTextNode(product.price.currentText));
          values.append(current);

          if (product.price.unitText) {
            const unit = document.createElement('span');
            unit.className = 'pw-rhg__unit';
            unit.textContent = `/ ${product.price.unitText}`;
            values.append(unit);
          }

          price.append(values);
          content.append(price);
        }

        link.append(media, content);
        item.append(link);
        this.configureCard(item, product);
        return item;
      }

      createSlot(product) {
        const cachedCard = this.createCachedCard(product);
        if (cachedCard) return cachedCard;

        const slot = document.createElement('li');
        slot.hidden = true;
        slot.dataset.pwEmptySlot = '';
        slot.dataset.productId = product.id;
        return slot;
      }

      async loadCandidates(products) {
        if (!Array.isArray(products) || !products.length) return;

        const token = this.loadToken;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const slots = products.map((product) => this.createSlot(product));
        const hasCachedCards = slots.some((slot) => slot.hasAttribute('data-pw-cached-card'));

        this.track.replaceChildren(...slots);
        this.track.setAttribute('aria-busy', 'false');
        this.shell.hidden = !hasCachedCards;
        if (hasCachedCards) {
          this.queueControlUpdate();
          this.observeExposure();
        }

        let cursor = 0;
        const workers = Array.from({ length: Math.min(3, products.length) }, async () => {
          while (cursor < products.length) {
            const index = cursor;
            cursor += 1;
            const product = products[index];

            try {
              const result = await this.fetchCard(product, signal);
              if (signal.aborted || token !== this.loadToken) return;

              if (result.card) {
                this.configureCard(result.card, product);
                slots[index].replaceWith(result.card);
                this.shell.hidden = false;
                this.queueControlUpdate();
                this.observeExposure();
              } else if (slots[index].hasAttribute('data-pw-empty-slot')) {
                slots[index].remove();
              }
            } catch (error) {
              if (error.name === 'AbortError') return;
              if (slots[index].hasAttribute('data-pw-empty-slot')) slots[index].remove();
            }
          }
        });

        await Promise.allSettled(workers);
        if (signal.aborted || token !== this.loadToken) return;

        this.track.setAttribute('aria-busy', 'false');
        this.abortController = null;

        if (!this.track.querySelector('[data-pw-live-card], [data-pw-cached-card]')) {
          this.hideSection();
          return;
        }

        this.shell.hidden = false;
        this.queueControlUpdate();
        this.observeExposure();
      }

      async fetchCard(product, signal) {
        const url = new URL(window.location.href);
        const root = this.dataset.routesRoot || '/';
        const normalizedRoot = root.endsWith('/') ? root : `${root}/`;

        url.pathname = `${normalizedRoot}products/${encodeURIComponent(product.handle)}`.replace(/\/+/g, '/');
        url.hash = '';
        url.searchParams.delete('variant');
        url.searchParams.delete('selling_plan');
        url.searchParams.delete('quantity');
        url.searchParams.set('section_id', this.dataset.cardSectionId);

        const response = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          signal
        });

        if (!response.ok) {
          return { card: null };
        }

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const card = documentFragment.querySelector('[data-pw-live-card][data-pw-current-card]');
        const matchesProduct = card && String(card.dataset.productId || '') === String(product.id);

        return {
          card: matchesProduct ? document.importNode(card, true) : null
        };
      }

      configureCard(card, product) {
        const secondary = card.querySelector('[data-pw-live-secondary]');
        const price = card.querySelector('[data-pw-live-price]');
        const fromLabel = card.querySelector('[data-pw-from-label]');

        if (secondary) {
          if (this.dataset.showSecondary !== 'true') {
            secondary.hidden = true;
          } else if (product.hasSecondaryOverride && product.secondaryText) {
            secondary.textContent = product.secondaryText;
            secondary.hidden = false;
          } else {
            secondary.hidden = !secondary.textContent.trim();
          }
        }

        if (price) price.hidden = this.dataset.showPrice !== 'true';
        if (fromLabel) fromLabel.textContent = this.dataset.fromLabel || '';
      }

      hideSection() {
        this.finishProgressPointer();
        this.exposureObserver?.disconnect();
        this.exposureObserver = null;
        if (this.shell) this.shell.hidden = true;
        if (this.navigation) this.navigation.hidden = true;
        if (this.progress) this.progress.hidden = true;
      }

      scrollByCard(direction) {
        const item = this.track?.querySelector('.pw-rhg__item:not([hidden])');
        if (!item) return;

        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const target = this.getLogicalScrollPosition() + direction * (item.getBoundingClientRect().width + gap);
        this.setLogicalScrollPosition(target, this.scrollBehavior());
      }

      scrollBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      isRtl() {
        return this.track && getComputedStyle(this.track).direction === 'rtl';
      }

      getRtlScrollType() {
        if (this.rtlScrollType) return this.rtlScrollType;

        const viewport = document.createElement('div');
        const content = document.createElement('div');
        viewport.dir = 'rtl';
        viewport.style.cssText = 'position:absolute;top:-9999px;width:4px;height:1px;overflow:scroll;visibility:hidden;';
        content.style.width = '8px';
        content.style.height = '1px';
        viewport.append(content);
        (document.body || document.documentElement).append(viewport);

        if (viewport.scrollLeft > 0) {
          this.rtlScrollType = 'default';
        } else {
          viewport.scrollLeft = 1;
          this.rtlScrollType = viewport.scrollLeft === 0 ? 'negative' : 'reverse';
        }

        viewport.remove();
        return this.rtlScrollType;
      }

      getLogicalScrollPosition() {
        if (!this.track) return 0;

        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        let position = this.track.scrollLeft;

        if (this.isRtl()) {
          const type = this.getRtlScrollType();
          if (type === 'negative') position = -position;
          if (type === 'default') position = maxScroll - position;
        }

        return Math.min(maxScroll, Math.max(0, position));
      }

      setLogicalScrollPosition(value, behavior = 'auto') {
        if (!this.track) return;

        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.min(maxScroll, Math.max(0, value));
        let rawPosition = position;

        if (this.isRtl()) {
          const type = this.getRtlScrollType();
          if (type === 'negative') rawPosition = -position;
          if (type === 'default') rawPosition = maxScroll - position;
        }

        this.track.scrollTo({ left: rawPosition, behavior });
      }

      progressGeometry() {
        if (!this.progressRail || !this.progressThumb) return null;

        const rail = this.progressRail.getBoundingClientRect();
        const thumb = this.progressThumb.getBoundingClientRect();
        const travel = Math.max(0, rail.width - thumb.width);

        return { rail, thumb, travel };
      }

      setScrollFromPointer(clientX, pointerOffset) {
        const geometry = this.progressGeometry();
        if (!geometry || geometry.travel <= 0) return;

        const physicalPosition = Math.min(
          1,
          Math.max(0, (clientX - geometry.rail.left - pointerOffset) / geometry.travel)
        );
        const logicalPosition = this.isRtl() ? 1 - physicalPosition : physicalPosition;
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);

        this.setLogicalScrollPosition(maxScroll * logicalPosition, 'auto');
        this.queueControlUpdate();
      }

      handleProgressPointerDown(event) {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;

        const geometry = this.progressGeometry();
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        if (!geometry || maxScroll <= 0) return;

        const onThumb = event.clientX >= geometry.thumb.left && event.clientX <= geometry.thumb.right;
        this.progressPointer = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          offset: onThumb ? event.clientX - geometry.thumb.left : geometry.thumb.width / 2,
          onThumb,
          dragging: event.pointerType === 'mouse',
          cancelled: false
        };

        this.progressControl.setAttribute('data-pw-pointer-focus', '');
        this.progressControl.setPointerCapture(event.pointerId);

        if (event.pointerType === 'mouse') {
          this.progressControl.focus({ preventScroll: true });
          this.classList.add('is-progress-dragging');
          if (!onThumb) this.setScrollFromPointer(event.clientX, this.progressPointer.offset);
        }
      }

      handleProgressPointerMove(event) {
        const state = this.progressPointer;
        if (!state || state.id !== event.pointerId || state.cancelled) return;

        if (!state.dragging) {
          const horizontalDistance = Math.abs(event.clientX - state.startX);
          const verticalDistance = Math.abs(event.clientY - state.startY);
          if (horizontalDistance < 6 && verticalDistance < 6) return;

          if (verticalDistance > horizontalDistance) {
            state.cancelled = true;
            return;
          }

          state.dragging = true;
          this.classList.add('is-progress-dragging');
        }

        event.preventDefault();
        this.setScrollFromPointer(event.clientX, state.offset);
      }

      handleProgressPointerEnd(event, allowTap) {
        const state = this.progressPointer;
        if (!state || state.id !== event.pointerId) return;

        const wasDragging = state.dragging;
        if (allowTap && !state.cancelled && !state.dragging && !state.onThumb) {
          this.setScrollFromPointer(event.clientX, state.offset);
        }

        this.finishProgressPointer(event.pointerId);
        if (wasDragging) this.snapToNearestCard();
      }

      handleProgressLostCapture(event) {
        if (this.progressPointer?.id !== event.pointerId) return;
        this.progressPointer = null;
        this.classList.remove('is-progress-dragging');
      }

      finishProgressPointer(pointerId) {
        const activePointerId = pointerId ?? this.progressPointer?.id;
        this.progressPointer = null;
        this.classList.remove('is-progress-dragging');

        if (
          activePointerId !== undefined
          && this.progressControl?.hasPointerCapture?.(activePointerId)
        ) {
          this.progressControl.releasePointerCapture(activePointerId);
        }
      }

      snapToNearestCard() {
        const item = this.track?.querySelector('.pw-rhg__item:not([hidden])');
        if (!item) return;

        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item.getBoundingClientRect().width + gap;
        if (step <= 0) return;

        const target = Math.round(this.getLogicalScrollPosition() / step) * step;
        this.setLogicalScrollPosition(target, this.scrollBehavior());
      }

      handleProgressKeyDown(event) {
        this.progressControl?.removeAttribute('data-pw-pointer-focus');
        if (!this.track) return;

        const item = this.track.querySelector('.pw-rhg__item:not([hidden])');
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const cardStep = item ? item.getBoundingClientRect().width + gap : 40;
        const current = this.getLogicalScrollPosition();
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        let target = null;

        if (event.key === 'ArrowLeft') target = current + (this.isRtl() ? cardStep : -cardStep);
        if (event.key === 'ArrowRight') target = current + (this.isRtl() ? -cardStep : cardStep);
        if (event.key === 'PageUp') target = current - this.track.clientWidth;
        if (event.key === 'PageDown') target = current + this.track.clientWidth;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = maxScroll;
        if (event.key === ' ') target = current + (event.shiftKey ? -this.track.clientWidth : this.track.clientWidth);

        if (target === null) return;
        event.preventDefault();
        this.setLogicalScrollPosition(target, this.scrollBehavior());
      }

      queueControlUpdate() {
        if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
        this.controlFrame = requestAnimationFrame(() => {
          this.controlFrame = null;
          this.updateControls();
        });
      }

      updateControls() {
        if (
          !this.track
          || !this.progress
          || !this.progressControl
          || !this.progressRail
          || !this.progressThumb
        ) return;

        const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
        if (this.navigation) this.navigation.hidden = !overflow;
        this.progress.hidden = !overflow;

        if (!overflow) {
          this.progressThumb.style.width = '100%';
          this.progressThumb.style.transform = 'translate3d(0, 0, 0)';
          this.progressControl.setAttribute('aria-valuenow', '0');
          return;
        }

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = this.getLogicalScrollPosition();
        const visibleRatio = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
        const railWidth = this.progressRail.getBoundingClientRect().width;
        const thumbWidth = Math.min(railWidth, Math.max(28, railWidth * visibleRatio));
        const travel = Math.max(0, railWidth - thumbWidth);
        const progressPosition = maxScroll > 0 ? scrollPosition / maxScroll : 0;
        const physicalPosition = this.isRtl() ? 1 - progressPosition : progressPosition;
        const percentage = Math.round(progressPosition * 100);

        this.progressThumb.style.width = `${thumbWidth}px`;
        this.progressThumb.style.transform = `translate3d(${physicalPosition * travel}px, 0, 0)`;
        this.progressControl.setAttribute('aria-valuenow', String(percentage));
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 2;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 2;
      }
    }

    customElements.define(elementName, PwRecentlyViewedProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-referral-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const banners = document.querySelectorAll('[data-pw-referral-banner][data-motion="true"]');
    if (!banners.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const active = new Set();
    let ticking = false;

    const update = () => {
      ticking = false;
      const viewport = window.innerHeight || 1;

      active.forEach((banner) => {
        const rect = banner.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const distance = (center - viewport / 2) / viewport;
        const clamped = Math.max(-1, Math.min(1, distance));
        const toast = 1 - Math.min(1, Math.abs(clamped) * 1.8);
        const rotation = clamped * -1.2;

        banner.style.setProperty('--pw-bg-x', `${clamped * -7}px`);
        banner.style.setProperty('--pw-bg-y', `${toast * -3}px`);
        banner.style.setProperty('--pw-fallback-x', `${clamped * -16}px`);
        banner.style.setProperty('--pw-fallback-y', `${toast * 7}px`);
        banner.style.setProperty('--pw-fallback-rotate', `${rotation * -.35}deg`);
        banner.style.setProperty('--pw-left-glass-x', `${toast * 10 + clamped * -4}px`);
        banner.style.setProperty('--pw-left-glass-y', `${toast * -5}px`);
        banner.style.setProperty('--pw-left-glass-rotate', `${-8 + rotation * -.5}deg`);
        banner.style.setProperty('--pw-left-glass-scale', String(1 + toast * .055));
        banner.style.setProperty('--pw-right-glass-x', `${toast * -10 + clamped * 4}px`);
        banner.style.setProperty('--pw-right-glass-y', `${toast * -5}px`);
        banner.style.setProperty('--pw-right-glass-rotate', `${8 + rotation * .5}deg`);
        banner.style.setProperty('--pw-right-glass-scale', String(1 + toast * .055));
        banner.style.setProperty('--pw-card-x', `${clamped * 8}px`);
        banner.style.setProperty('--pw-card-y', `${toast * -5}px`);
        banner.style.setProperty('--pw-card-rotate', `${-2 + rotation}deg`);
        banner.style.setProperty('--pw-ribbon-x', `${clamped * 10}px`);
        banner.style.setProperty('--pw-ribbon-y', `${toast * -6}px`);
        banner.style.setProperty('--pw-ribbon-rotate', `${18 + rotation}deg`);
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          active.add(entry.target);
        } else {
          active.delete(entry.target);
        }
      });
      requestUpdate();
    }, { rootMargin: '120px 0px' });

    banners.forEach((banner) => observer.observe(banner));
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-wine-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const validStyles = ['all', 'rood', 'wit', 'rose', 'mousserend', 'dessert', 'alcoholvrij'];

    function initDirectory(root) {
      if (root.dataset.pwReady === 'true') return;

      const queryKey = root.dataset.queryKey || 'soort';
      const params = new URLSearchParams(window.location.search);
      let style = params.get(queryKey) || root.dataset.initialStyle || 'all';
      if (!validStyles.includes(style)) style = 'all';

      const searchInput = root.querySelector('.pw-wd__search-input');
      const tabs = [...root.querySelectorAll('[data-style]')];
      const empty = root.querySelector('.pw-wd__empty');
      const status = root.querySelector('.pw-wd__status');
      let searchTerm = '';

      function readSetting(selector) {
        const element = root.querySelector(selector);
        if (!element) return '';
        try {
          return JSON.parse(element.textContent) || '';
        } catch (error) {
          return '';
        }
      }

      function lines(value) {
        return value.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
      }

      const styleMap = {};
      lines(readSetting('[data-pw-style-map]')).forEach((line) => {
        const [key, collectionHandle, filterValue, label] = line.split('|').map((part) => part.trim());
        if (key && collectionHandle) styleMap[key] = { collectionHandle, filterValue, label };
      });

      if (!styleMap.alcoholvrij) {
        styleMap.alcoholvrij = { collectionHandle: 'alcoholvrije-wijn', filterValue: '', label: 'Alcoholvrij' };
      }

      const verifiedStyleFilterValues = {
        rood: 'gid://shopify/FilterSettingGroup/74711119',
        wit: 'gid://shopify/FilterSettingGroup/74743887',
        rose: 'gid://shopify/FilterSettingGroup/74776655',
        mousserend: 'gid://shopify/FilterSettingGroup/74809423',
        dessert: 'gid://shopify/FilterSettingGroup/74907727'
      };

      Object.entries(verifiedStyleFilterValues).forEach(([key, filterValue]) => {
        if (styleMap[key] && !styleMap[key].filterValue) styleMap[key].filterValue = filterValue;
      });

      const parameterMap = {};
      lines(readSetting('[data-pw-parameter-map]')).forEach((line) => {
        const [key, parameter] = line.split('|').map((part) => part.trim());
        if (key && parameter) parameterMap[key] = parameter;
      });

      const filterOverrides = {};
      lines(readSetting('[data-pw-filter-overrides]')).forEach((line) => {
        const [scope, label, value] = line.split('|').map((part) => part.trim());
        if (scope && label && value) filterOverrides[`${scope}|${label.toLocaleLowerCase('nl')}`] = value;
      });

      function nativeFilterValue(scope, value) {
        if (!value) return '';
        return filterOverrides[`${scope}|${value.trim().toLocaleLowerCase('nl')}`] || value.trim();
      }

      function countFor(element) {
        return Number(element.dataset[`count${style.charAt(0).toUpperCase()}${style.slice(1)}`] || 0);
      }

      function updateLink(link) {
        if (style === 'all' || !styleMap[style]) {
          link.href = link.dataset.baseUrl;
          return;
        }

        const styleConfig = styleMap[style];
        const url = new URL(`${root.dataset.collectionsUrl}/${styleConfig.collectionHandle}`, window.location.origin);

        if (style !== 'alcoholvrij' && styleConfig.filterValue && parameterMap.soort) {
          url.searchParams.set(parameterMap.soort, styleConfig.filterValue);
        }
        if (link.dataset.filterLand && parameterMap.land) {
          url.searchParams.set(parameterMap.land, nativeFilterValue('land', link.dataset.filterLand));
        }
        if (link.dataset.filterRegion && parameterMap.regio) {
          url.searchParams.set(parameterMap.regio, nativeFilterValue('regio', link.dataset.filterRegion));
        }
        if (link.dataset.filterGrape && parameterMap.druif) {
          url.searchParams.set(parameterMap.druif, nativeFilterValue('druif', link.dataset.filterGrape));
        }
        if (root.dataset.sortBy) url.searchParams.set('sort_by', root.dataset.sortBy);

        link.href = `${url.pathname}${url.search}`;
      }

      function matchesText(element, inheritedMatch = false) {
        if (!searchTerm) return true;
        return inheritedMatch || (element.dataset.search || '').includes(searchTerm);
      }

      function applyFilters() {
        let visibleCount = 0;

        if (root.dataset.mode === 'countries') {
          root.querySelectorAll('.pw-wd__country').forEach((country) => {
            const countryStyleMatch = countFor(country) > 0;
            const countryTextMatch = matchesText(country);
            let visibleRegions = 0;

            country.querySelectorAll('.pw-wd__region').forEach((region) => {
              const showRegion = countFor(region) > 0 && matchesText(region, countryTextMatch);
              region.hidden = !showRegion;
              if (showRegion) visibleRegions += 1;
            });

            const showCountry = countryStyleMatch && (countryTextMatch || visibleRegions > 0 || !searchTerm);
            country.hidden = !showCountry;
            if (showCountry) visibleCount += 1;
          });

          if (root.dataset.openFirst === 'true') {
            const visibleCountries = [...root.querySelectorAll('.pw-wd__country:not([hidden])')];
            if (visibleCountries.length && !visibleCountries.some((country) => country.open)) visibleCountries[0].open = true;
          }
        } else {
          root.querySelectorAll('.pw-wd__grape').forEach((grape) => {
            const showGrape = countFor(grape) > 0 && matchesText(grape);
            grape.hidden = !showGrape;
            if (showGrape) visibleCount += 1;
          });

          root.querySelectorAll('.pw-wd__grape-group').forEach((group) => {
            const hasVisibleGrape = [...group.querySelectorAll('.pw-wd__grape')].some((grape) => !grape.hidden);
            group.hidden = !hasVisibleGrape;
            const letterLink = root.querySelector(`[data-letter-link="${CSS.escape(group.dataset.letter)}"]`);
            if (letterLink) letterLink.hidden = !hasVisibleGrape;
          });
        }

        root.querySelectorAll('[data-count-output]').forEach((output) => {
          const item = output.closest('[data-count-all]');
          if (item) output.textContent = countFor(item);
        });

        root.querySelectorAll('.pw-wd__collection-link').forEach(updateLink);
        tabs.forEach((tab) => tab.setAttribute('aria-current', String(tab.dataset.style === style)));
        if (empty) empty.hidden = visibleCount > 0;
        if (status) {
          const label = root.dataset.mode === 'countries' ? root.dataset.statusCountries : root.dataset.statusGrapes;
          status.textContent = `${visibleCount} ${label}`;
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          style = tab.dataset.style;
          const url = new URL(window.location.href);
          if (style === 'all') url.searchParams.delete(queryKey);
          else url.searchParams.set(queryKey, style);
          window.history.replaceState({}, '', url);
          applyFilters();
        });
      });

      if (searchInput) {
        searchInput.addEventListener('input', () => {
          searchTerm = searchInput.value.trim().toLocaleLowerCase('nl');
          applyFilters();
        });
      }

      root.dataset.pwReady = 'true';
      applyFilters();
    }

    function initAll(scope = document) {
      scope.querySelectorAll('.pw-wd').forEach(initDirectory);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wine-specifications-v1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-wine-specs-central-v5')) {
    class PWWineSpecs extends HTMLElement {
      async connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.initDisclosures(options);
        this.initProductFacts(options);
        if (this.dataset.mapEnabled !== 'true' || !this.dataset.mapRegion?.trim() || this.dataset.mapRegion.trim() === '-') return;
        this.mapPanel = this.querySelector('[data-map-panel]');
        this.mapShell = this.querySelector('[data-map-shell]');
        this.mapViewport = this.querySelector('[data-map-viewport]');
        this.mapTiles = this.querySelector('[data-map-tiles]');
        this.mapMarkers = this.querySelector('[data-map-markers]');
        this.mapAreaLayer = this.querySelector('[data-map-area-layer]');
        this.mapError = this.querySelector('[data-map-error]');
        this.mapLink = this.querySelector('[data-map-link]');
        if (!this.mapShell || !this.mapViewport || !this.mapLink) return;
        const controller = this.controller;
        if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
          await new Promise(resolve => {
            const ready = () => {
              this.atlasIntersection?.disconnect();
              controller.signal.removeEventListener('abort', ready);
              resolve();
            };
            this.atlasIntersection = new IntersectionObserver(entries => {
              if (entries.some(entry => entry.isIntersecting)) ready();
            }, { rootMargin: '600px' });
            controller.signal.addEventListener('abort', ready, { once: true });
            this.atlasIntersection.observe(this);
          });
        }
        if (controller.signal.aborted || this.controller !== controller || !this.isConnected) return;
        try {
          const url = this.dataset.atlasUrl;
          window.PWOriginAtlasLoads = window.PWOriginAtlasLoads || {};
          if (!window.PWOriginAtlasLoads[url]) {
            window.PWOriginAtlasLoads[url] = new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = url;
              script.async = true;
              script.onload = () => window.PWOriginAtlas?.resolve ? resolve(window.PWOriginAtlas) : reject(new Error('Atlas unavailable'));
              script.onerror = () => { delete window.PWOriginAtlasLoads[url]; script.remove(); reject(new Error('Atlas load failed')); };
              document.head.append(script);
            });
          }
          const atlas = await window.PWOriginAtlasLoads[url];
          if (controller.signal.aborted || this.controller !== controller || !this.isConnected) return;
          const originInput = {country:this.dataset.mapCountry,region:this.dataset.mapRegion,subregion:this.dataset.mapSubregion,area:this.dataset.mapOriginArea};
          let result = atlas.resolve({...originInput,country:this.dataset.mapCountryKey || originInput.country,region:this.dataset.mapRegionKey || originInput.region});
          if (result.status !== 'ready') result = atlas.resolve(originInput);
          this.dataset.mapResolution = result.status;
          this.dataset.mapArea = JSON.stringify(result.feature);
          this.dataset.mapMarker = JSON.stringify(result.marker);
        } catch (error) {
          if (controller.signal.aborted || this.controller !== controller) return;
          this.dataset.mapResolution = 'atlas-load-failed';
          return;
        }
        this.points = [];
        this.area = this.readArea();
        this.markers = this.readMarkers();
        if (!this.area) {
          if (this.mapPanel) this.mapPanel.hidden = true;
          this.mapShell.hidden = true;
          this.mapLink.hidden = true;
          return;
        }
        this.mapLink.href = this.area
          ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(this.area.properties.search_query || this.area.properties.name || this.dataset.mapSearch || '')
          : this.points.length === 1
          ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(this.points[0].lat + ',' + this.points[0].lng)
          : 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(this.dataset.mapSearch || this.points[0].lat + ',' + this.points[0].lng);
        this.mapLink.hidden = false;
        this.mapShell.hidden = false;
        if (this.mapPanel) this.mapPanel.hidden = false;
        this.moveCountryFlag();
        if (this.area) this.setAreaCaption();
        else if (this.fromComponents) {
          this.mapViewport.setAttribute('aria-label', this.dataset.multipleNote || this.dataset.originName || '');
        }
        if ('IntersectionObserver' in window) {
          this.intersection = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.intersection.disconnect();
              this.startMap();
            }
          }, { rootMargin: '250px' });
          this.intersection.observe(this.mapShell);
        } else {
          this.startMap();
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.vectorTimer);
        const vector = this.vectorMap;
        this.vectorMap = null;
        vector?.remove();
        this.vectorLoading = false;
        this.vectorReady = false;
        this.atlasIntersection?.disconnect();
        this.intersection?.disconnect();
        this.resize?.disconnect();
        clearTimeout(this.mapTimer);
        clearTimeout(this.resizeTimer);
        this.generation = (this.generation || 0) + 1;
        this.mapStarted = false;
      }


      initDisclosures(options) {
        this.disclosures = Array.from(this.querySelectorAll('details[data-spec-disclosure]'));
        if (!this.disclosures.length) return;
        this.disclosureMedia = window.matchMedia('(max-width: 900px)');
        const update = () => {
          const mobile = this.disclosureMedia.matches;
          this.placeOriginMap(mobile);
          this.disclosures.forEach(details => {
            details.open = !mobile;
            const summary = details.querySelector('summary');
            if (mobile) { summary.removeAttribute('tabindex'); summary.removeAttribute('aria-disabled'); }
            else { summary.tabIndex = -1; summary.setAttribute('aria-disabled', 'true'); }
          });
        };
        this.disclosures.forEach(details => details.querySelector('summary').addEventListener('click', event => {
          if (!this.disclosureMedia.matches) event.preventDefault();
        }, options));
        this.disclosureMedia.addEventListener('change', update, options);
        update();
      }

      placeOriginMap(mobile) {
        const block = this.querySelector('[data-origin-block]');
        const panel = block?.querySelector('[data-map-panel]');
        const content = block?.querySelector('.pw-specs__group--origin > .pw-specs__group-content');
        if (!panel || !content) return;
        const target = mobile ? block : content;
        if (panel.parentElement !== target) target.append(panel);
      }

      moveCountryFlag() {
        const slot = this.querySelector('[data-map-flag]');
        const flag = this.querySelector('[data-spec="country"] [data-country-flag], [data-spec="country"] .pw-specs__flag');
        if (!slot || !flag) return;
        this.countryFlagHome = flag.parentElement;
        this.countryFlagNext = flag.nextSibling;
        this.countryFlag = flag;
        slot.append(flag);
      }

      restoreCountryFlag() {
        if (!this.countryFlag || !this.countryFlagHome) return;
        const next = this.countryFlagNext?.parentNode === this.countryFlagHome ? this.countryFlagNext : null;
        this.countryFlagHome.insertBefore(this.countryFlag, next);
        this.countryFlag = null;
      }

      initProductFacts(options) {
        this.addEventListener('error', event => {
          if (event.target?.matches?.('[data-package-image]')) event.target.hidden = true;
        }, { ...options, capture: true });
        const variants = this.parseData(this.dataset.variants);
        this.variants = new Map((Array.isArray(variants) ? variants : []).map(variant => [String(variant.id), variant]));
        this.skuNode = this.querySelector('[data-current-sku]');
        this.offerNode = this.querySelector('[data-current-offer]');
        this.deliveryNode = this.querySelector('[data-current-delivery]');
        this.querySelectorAll('[data-country-flag]').forEach(flag => flag.addEventListener('error', () => { flag.hidden = true; }, options));
        const onVariant = event => {
          const detail = event.detail || {};
          const variant = detail.variant || detail.data?.variant || detail;
          if (variant?.id) this.setVariant(String(variant.id));
        };
        ['variant:change', 'variant:changed', 'variant-change', 'product:variant-change', 'product:variant-changed', 'theme:variant:change'].forEach(name => document.addEventListener(name, onVariant, options));
        document.addEventListener('change', event => {
          const form = event.target?.closest?.('form[action*="/cart/add"]');
          if (!form) return;
          queueMicrotask(() => {
            if (options.signal.aborted) return;
            const id = form.querySelector('[name="id"]')?.value;
            if (id) this.setVariant(String(id));
          });
        }, options);
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          if (id) this.setVariant(id);
        }, options);
      }

      setVariant(id) {
        const variant = this.variants?.get(String(id));
        if (!variant) return;
        if (this.skuNode) this.skuNode.textContent = variant.sku || this.dataset.missingLabel;
        const packageTemplate = this.querySelector('template[data-package-variant="' + String(id) + '"]');
        const packageContent = this.querySelector('[data-package-content]');
        if (packageTemplate && packageContent && this.dataset.selectedVariant !== String(id)) {
          packageContent.replaceChildren(packageTemplate.content.cloneNode(true));
          const preview = this.querySelector('[data-package-preview]');
          const body = packageContent.querySelector('[data-package-body]');
          if (preview && body) preview.textContent = body.dataset.summary || '-';
        }
        this.dataset.selectedVariant = String(id);
        if (this.deliveryNode && !this.deliveryNode.dataset.pwFulfilment) {
          const hasDelivery = this.deliveryNode.textContent.trim() && this.deliveryNode.textContent.trim() !== '-';
          this.deliveryNode.classList.toggle('pw-specs__delivery--in-stock', variant.in_stock === true && Boolean(hasDelivery));
        }
        if (!this.offerNode) return;
        let label = this.dataset.noneLabel;
        let state = 'none';
        if (this.dataset.tierState === 'active') {
          label = this.dataset.tierLabel;
          state = 'active';
        } else if (variant.bottle_discount === true) {
          label = this.dataset.bottleLabel;
          state = 'active';
        } else if (this.dataset.tierState === 'unknown') {
          label = this.dataset.unknownLabel;
          state = 'unknown';
        }
        this.offerNode.textContent = label;
        this.offerNode.className = 'pw-specs__offer pw-specs__offer--' + state;
      }

      parseData(raw) {
        if (!raw) return null;
        try { return JSON.parse(raw); } catch { return null; }
      }

      coordinate(value) {
        if (typeof value !== 'number' && typeof value !== 'string') return null;
        if (typeof value === 'string' && !/^[+-]?\d+(?:\.\d+)?$/.test(value.trim())) return null;
        const number = Number(value);
        return Number.isFinite(number) ? number : null;
      }

      point(value, label) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
        const lat = this.coordinate(value.lat);
        const lng = this.coordinate(value.lng);
        if (lat === null || lng === null || lat < -85.05112878 || lat > 85.05112878 || lng < -180 || lng > 180) return null;
        return { lat, lng, label: typeof label === 'string' ? label : '' };
      }

      readPoints() {
        const components = this.parseData(this.dataset.components);
        const result = [];
        this.fromComponents = false;
        if (Array.isArray(components)) {
          for (const component of components.slice(0, 50)) {
            if (!component || typeof component !== 'object') continue;
            const label = component.vineyard_name || component.region || component.component_name || this.dataset.originName;
            const point = this.point(component.coordinates, label);
            if (point && !result.some(item => item.lat === point.lat && item.lng === point.lng)) result.push(point);
          }
        }
        if (result.length) {
          this.fromComponents = true;
          return result;
        }
        const single = this.point(this.parseData(this.dataset.coordinates), this.dataset.originName);
        return single ? [single] : [];
      }

      readArea() {
        const raw = this.dataset.mapArea;
        if (!raw || raw.length > 500000) return null;
        const feature = this.parseData(raw);
        if (feature?.type !== 'Feature' || !feature.geometry || feature.properties?.schema_version !== 1 || feature.properties.map_role !== 'region') return null;
        const geometry = feature.geometry;
        const polygons = geometry.type === 'Polygon' ? [geometry.coordinates] : geometry.type === 'MultiPolygon' ? geometry.coordinates : null;
        if (!Array.isArray(polygons) || !polygons.length || polygons.length > 1000) return null;
        let count = 0;
        const rings = [];
        const outlines = [];
        for (const polygon of polygons) {
          if (!Array.isArray(polygon) || !polygon.length) return null;
          for (const [ringIndex, ring] of polygon.entries()) {
            if (!Array.isArray(ring) || ring.length < 4) return null;
            const points = [];
            for (const coordinate of ring) {
              if (++count > 12000 || !Array.isArray(coordinate) || coordinate.length < 2) return null;
              const point = this.point({ lng: coordinate[0], lat: coordinate[1] }, '');
              if (!point) return null;
              points.push(point);
            }
            const first = points[0], last = points[points.length - 1];
            if (first.lat !== last.lat || first.lng !== last.lng) return null;
            rings.push(points);
            if (ringIndex === 0) outlines.push(points);
          }
        }
        return { rings, outlines, points: rings.flat(), properties: feature.properties };
      }

      readMarkers() {
        if (!this.area) return [];
        const marker = this.parseData(this.dataset.mapMarker) || this.area.properties.marker;
        if (!marker || typeof marker.label !== 'string' || !marker.label.trim()) return [];
        const point = this.point(marker, marker.label.trim().slice(0, 100));
        return point ? [point] : [];
      }

      drawMarkers(geometry, width, height) {
        this.mapMarkers.replaceChildren();
        for (const point of geometry.markers) {
          const x = point.x * geometry.world - geometry.left;
          const y = point.y * geometry.world - geometry.top;
          const marker = document.createElement('span');
          marker.className = 'pw-specs__pin';
          marker.style.left = x + 'px';
          marker.style.top = y + 'px';
          marker.title = point.label;
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 34 124');
          // Red bottle with a blank white label and a separate location tip.
          const parts = [
            ['path', { d: 'M12.5 1H21.5Q23.5 1 23.5 3V6Q23.5 6.7 22.8 7.2V24.8C22.8 28 24.1 29.5 27.1 31.5C31.4 34.5 32.3 38.6 32.3 42V98.6Q32.3 101.6 29.3 101.6H4.7Q1.7 101.6 1.7 98.6V42C1.7 38.6 2.6 34.5 6.9 31.5C9.9 29.5 11.2 28 11.2 24.8V7.2Q10.5 6.7 10.5 6V3Q10.5 1 12.5 1Z', fill: '#f44336' }],
            ['rect', { x: '6', y: '50.4', width: '22', height: '36.8', rx: '1.8', fill: '#ffffff' }],
            ['path', { d: 'M8 106.4H26Q27.7 106.4 26.7 108L18 123.2Q17 124.8 16 123.2L7.3 108Q6.3 106.4 8 106.4Z', fill: '#f44336' }]
          ];
          for (const [tag, attributes] of parts) {
            const part = document.createElementNS('http://www.w3.org/2000/svg', tag);
            for (const [key, value] of Object.entries(attributes)) part.setAttribute(key, value);
            svg.append(part);
          }
          marker.append(svg);
          this.mapMarkers.append(marker);
          if (point.label) {
            const label = document.createElement('span');
            label.className = 'pw-specs__pin-label';
            label.textContent = point.label;
            this.mapMarkers.append(label);
            const box = label.getBoundingClientRect();
            const left = x + 19 + box.width <= width - 8 ? x + 19 : x - 19 - box.width;
            label.style.left = Math.max(8, Math.min(width - box.width - 8, left)) + 'px';
            label.style.top = Math.max(8, Math.min(height - box.height - 8, y - 36)) + 'px';
          }
        }
      }

      setAreaCaption() {
        const properties = this.area.properties;
        const language = this.dataset.mapLanguage || 'nl';
        const heading = this.querySelector('[data-map-title]');
        if (heading) heading.textContent = (this.dataset.mapHeading || '') + ': ' + (this.dataset.mapRegion || properties.name || '');
        const description = properties.description?.[language] || properties.description?.en;
        this.mapViewport.setAttribute('aria-label', typeof description === 'string' ? description : properties.name || '');
        const source = this.querySelector('[data-map-area-source]');
        if (!source || typeof properties.source_url !== 'string' || typeof properties.source_label !== 'string') return;
        try {
          const url = new URL(properties.source_url);
          if (url.protocol !== 'https:' || url.username || url.password) return;
          source.textContent = ({ nl: 'Grenzen: ', en: 'Boundaries: ', fr: 'Limites : ' })[language] || 'Boundaries: ';
          const link = document.createElement('a');
          link.href = url.href;
          link.textContent = properties.source_label;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          source.append(link);
          if (typeof properties.license_url === 'string') {
            const licenseUrl = new URL(properties.license_url);
            if (licenseUrl.protocol === 'https:' && !licenseUrl.username && !licenseUrl.password) {
              const license = document.createElement('a');
              license.href = licenseUrl.href;
              license.textContent = properties.license || 'License';
              license.target = '_blank';
              license.rel = 'noopener noreferrer';
              source.append(' · ', license);
            }
          }
          const pinSource = properties.marker?.source;
          if (pinSource?.url && pinSource.url !== properties.source_url && pinSource.label !== 'OpenStreetMap contributors') {
            const pinUrl = new URL(pinSource.url);
            if (pinUrl.protocol === 'https:' && !pinUrl.username && !pinUrl.password) {
              const pinLink = document.createElement('a');
              pinLink.href = pinUrl.href;
              pinLink.textContent = pinSource.label;
              pinLink.target = '_blank';
              pinLink.rel = 'noopener noreferrer';
              source.append(' · Pin: ', pinLink);
            }
          }
          source.hidden = false;
        } catch { source.hidden = true; }
      }

      drawArea(geometry, width, height) {
        if (!this.mapAreaLayer) return;
        this.mapAreaLayer.replaceChildren();
        this.mapAreaLayer.toggleAttribute('hidden', !this.area);
        if (!this.area) return;
        this.mapAreaLayer.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
        let index = 0;
        const paths = this.area.rings.map(ring => {
          return ring.map((point, position) => {
            const projected = geometry.points[index++];
            const x = projected.x * geometry.world - geometry.left;
            const y = projected.y * geometry.world - geometry.top;
            return (position ? 'L' : 'M') + x.toFixed(2) + ' ' + y.toFixed(2);
          }).join(' ') + 'Z';
        });
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', paths.join(' '));
        path.setAttribute('fill-rule', 'evenodd');
        this.mapAreaLayer.append(path);
      }

      startMap() {
        if (this.mapStarted || !this.isConnected) return;
        this.mapStarted = true;
        this.drawMap();
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => {
            const bounds = this.mapViewport.getBoundingClientRect();
            const width = Math.round(bounds.width);
            const height = Math.round(bounds.height);
            if (!width || !height || (width === this.lastWidth && height === this.lastHeight)) return;
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => this.drawMap(), 180);
          });
          this.resize.observe(this.mapViewport);
        }
      }

      geometry(width, height) {
        const markers = this.markers || this.readMarkers();
        const regionPoints = this.area ? this.area.points : [];
        const project = point => ({
          ...point,
          x: (point.lng + 180) / 360,
          y: (1 - Math.asinh(Math.tan(point.lat * Math.PI / 180)) / Math.PI) / 2
        });
        const projected = [...regionPoints, ...markers].map(project);
        const sorted = projected.map(point => point.x).sort((a, b) => a - b);
        let largestGap = -1;
        let start = sorted[0];
        for (let index = 0; index < sorted.length; index++) {
          const next = index + 1 < sorted.length ? sorted[index + 1] : sorted[0] + 1;
          if (next - sorted[index] > largestGap) {
            largestGap = next - sorted[index];
            start = next % 1;
          }
        }
        const wrapped = projected.map(point => ({ ...point, x: point.x < start - 1e-10 ? point.x + 1 : point.x }));
        const outlines = (this.area?.outlines || []).map(ring => {
          const points = ring.map(project).map(point => ({ ...point, x: point.x < start - 1e-10 ? point.x + 1 : point.x }));
          let area = 0;
          for (let index = 1; index < points.length; index++) area += points[index - 1].x * points[index].y - points[index].x * points[index - 1].y;
          return { points, area: Math.abs(area / 2), minX: Math.min(...points.map(point => point.x)), maxX: Math.max(...points.map(point => point.x)), minY: Math.min(...points.map(point => point.y)), maxY: Math.max(...points.map(point => point.y)) };
        });
        const largest = outlines.reduce((best, polygon) => !best || polygon.area > best.area ? polygon : best, null);
        let framing = wrapped;
        if (largest?.area > 0) {
          const nearby = Math.max(largest.maxX - largest.minX, largest.maxY - largest.minY) * 0.25;
          const local = outlines.filter(polygon => {
            const distanceX = Math.max(0, largest.minX - polygon.maxX, polygon.minX - largest.maxX);
            const distanceY = Math.max(0, largest.minY - polygon.maxY, polygon.minY - largest.maxY);
            return polygon.area >= largest.area * 0.01 || Math.hypot(distanceX, distanceY) <= nearby;
          });
          framing = [...local.flatMap(polygon => polygon.points), ...wrapped.slice(regionPoints.length)];
        }
        const minX = Math.min(...framing.map(point => point.x));
        const maxX = Math.max(...framing.map(point => point.x));
        const minY = Math.min(...framing.map(point => point.y));
        const maxY = Math.max(...framing.map(point => point.y));
        const context = Math.max(1, Math.min(4, Number(this.area?.properties.view_context) || Number(this.dataset.mapContext) || 2));
        let zoom = this.area ? 14 : Math.max(2, Math.min(14, (Number(this.dataset.mapZoom) || 10) - 1));
        while (zoom > 0 && ((maxX - minX) * context * 256 * 2 ** zoom > Math.max(40, width - 48) || (maxY - minY) * context * 256 * 2 ** zoom > Math.max(40, height - 76))) zoom--;
        let world = 256 * 2 ** zoom;
        if (this.area) {
          const fitX = (width - 48) / Math.max((maxX - minX) * context, 1e-12);
          const fitY = (height - 76) / Math.max((maxY - minY) * context, 1e-12);
          world = Math.max(256, Math.min(256 * 2 ** 14, fitX, fitY));
          zoom = Math.max(0, Math.ceil(Math.log2(world / 256)));
        }
        const pixelRatio = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
        zoom = Math.max(0, Math.min(19, Math.ceil(Math.log2(world * pixelRatio / 256))));
        const tileSize = world / 2 ** zoom;
        return { points: wrapped.slice(0, regionPoints.length), markers: wrapped.slice(regionPoints.length), zoom, world, tileSize, left: (minX + maxX) / 2 * world - width / 2, top: (minY + maxY) / 2 * world - height / 2 };
      }

      loadVectorLibrary() {
        if (window.maplibregl) return Promise.resolve(window.maplibregl);
        if (!window.PWMapLibreLoad) {
          window.PWMapLibreLoad = new Promise((resolve, reject) => {
            const css = document.createElement('link');
            css.rel = 'stylesheet';
            css.href = 'https://unpkg.com/maplibre-gl@5.6.2/dist/maplibre-gl.css';
            document.head.append(css);
            const script = document.createElement('script');
            script.src = 'https://unpkg.com/maplibre-gl@5.6.2/dist/maplibre-gl.js';
            script.async = true;
            const timer = setTimeout(() => reject(new Error('Map library timeout')), 20000);
            script.onload = () => { clearTimeout(timer); window.maplibregl ? resolve(window.maplibregl) : reject(new Error('Map library unavailable')); };
            script.onerror = () => { clearTimeout(timer); reject(new Error('Map library unavailable')); };
            document.head.append(script);
          });
        }
        return window.PWMapLibreLoad;
      }

      vectorStyle() {
        return {"version":8,"sources":{"ne2_shaded":{"maxzoom":6,"tileSize":256,"tiles":["https://tiles.openfreemap.org/natural_earth/ne2sr/{z}/{x}/{y}.png"],"type":"raster"},"openmaptiles":{"type":"vector","url":"https://tiles.openfreemap.org/planet"},"pw-reference-cities":{"type":"geojson","data":{"type":"FeatureCollection","features":[{"type":"Feature","geometry":{"type":"Point","coordinates":[-8.61053466796875,41.14970617453724]},"properties":{"name":"Porto"},"id":29863001661}]}}},"sprite":"https://tiles.openfreemap.org/sprites/ofm_f384/ofm","glyphs":"https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf","layers":[{"id":"background","type":"background","paint":{"background-color":"#f6f4ec"}},{"id":"park","type":"fill","source":"openmaptiles","source-layer":"park","filter":["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],"paint":{"fill-color":"#e4edd9"}},{"id":"water","type":"fill","source":"openmaptiles","source-layer":"water","filter":["all",["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],["!=",["get","brunnel"],"tunnel"]],"paint":{"fill-antialias":true,"fill-color":"#b8dceb"}},{"id":"landcover_ice_shelf","type":"fill","source":"openmaptiles","source-layer":"landcover","maxzoom":8,"filter":["all",["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],["==",["get","subclass"],"ice_shelf"]],"paint":{"fill-color":"hsl(0,0%,98%)","fill-opacity":0.7}},{"id":"landcover_glacier","type":"fill","source":"openmaptiles","source-layer":"landcover","maxzoom":8,"filter":["all",["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],["==",["get","subclass"],"glacier"]],"paint":{"fill-color":"hsl(0,0%,98%)","fill-opacity":["interpolate",["linear"],["zoom"],0,1,8,0.5]}},{"id":"landuse_residential","type":"fill","source":"openmaptiles","source-layer":"landuse","maxzoom":16,"filter":["all",["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],["==",["get","class"],"residential"]],"paint":{"fill-color":"#ede9df","fill-opacity":["interpolate",["exponential",0.6],["zoom"],8,0.8,9,0.6]}},{"id":"landcover_wood","type":"fill","source":"openmaptiles","source-layer":"landcover","minzoom":10,"filter":["all",["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],["==",["get","class"],"wood"]],"paint":{"fill-color":"#dce8d0","fill-opacity":["interpolate",["linear"],["zoom"],8,0,12,1]}},{"id":"waterway","type":"line","source":"openmaptiles","source-layer":"waterway","filter":["match",["geometry-type"],["LineString","MultiLineString"],true,false],"paint":{"line-color":"#90bfd5"}},{"id":"building","type":"fill","source":"openmaptiles","source-layer":"building","minzoom":12,"paint":{"fill-antialias":true,"fill-color":"#e6e1d6","fill-outline-color":"rgb(219, 219, 218)"}},{"id":"tunnel_motorway_casing","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["==",["get","brunnel"],"tunnel"],["==",["get","class"],"motorway"]]],"layout":{"line-cap":"butt","line-join":"miter"},"paint":{"line-color":"rgb(213, 213, 213)","line-opacity":1,"line-width":["interpolate",["exponential",1.4],["zoom"],5.8,0,6,3,20,40]}},{"id":"tunnel_motorway_inner","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["==",["get","brunnel"],"tunnel"],["==",["get","class"],"motorway"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"rgb(234,234,234)","line-width":["interpolate",["exponential",1.4],["zoom"],4,2,6,1.3,20,30]}},{"id":"aeroway-taxiway","type":"line","source":"openmaptiles","source-layer":"aeroway","minzoom":12,"filter":["match",["get","class"],["taxiway"],true,false],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(0,0%,88%)","line-opacity":1,"line-width":["interpolate",["exponential",1.55],["zoom"],13,1.8,20,20]}},{"id":"aeroway-runway-casing","type":"line","source":"openmaptiles","source-layer":"aeroway","minzoom":11,"filter":["match",["get","class"],["runway"],true,false],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(0,0%,88%)","line-opacity":1,"line-width":["interpolate",["exponential",1.5],["zoom"],11,6,17,55]}},{"id":"aeroway-area","type":"fill","source":"openmaptiles","source-layer":"aeroway","minzoom":4,"filter":["all",["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],["match",["get","class"],["runway","taxiway"],true,false]],"paint":{"fill-color":"rgba(255, 255, 255, 1)","fill-opacity":["interpolate",["linear"],["zoom"],13,0,14,1]}},{"id":"aeroway-runway","type":"line","source":"openmaptiles","source-layer":"aeroway","minzoom":11,"filter":["all",["match",["get","class"],["runway"],true,false],["match",["geometry-type"],["LineString","MultiLineString"],true,false]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"rgba(255, 255, 255, 1)","line-opacity":1,"line-width":["interpolate",["exponential",1.5],["zoom"],11,4,17,50]}},{"id":"road_area_pier","type":"fill","source":"openmaptiles","source-layer":"transportation","filter":["all",["match",["geometry-type"],["MultiPolygon","Polygon"],true,false],["==",["get","class"],"pier"]],"paint":{"fill-antialias":true,"fill-color":"#f6f4ec"}},{"id":"road_pier","type":"line","source":"openmaptiles","source-layer":"transportation","filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["match",["get","class"],["pier"],true,false]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#f6f4ec","line-width":["interpolate",["exponential",1.2],["zoom"],15,1,17,4]}},{"id":"highway_path","type":"line","source":"openmaptiles","source-layer":"transportation","filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["==",["get","class"],"path"]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"rgb(234, 234, 234)","line-opacity":0.9,"line-width":["interpolate",["exponential",1.2],["zoom"],13,1,20,10]}},{"id":"highway_minor","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":8,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["match",["get","class"],["minor","service","track"],true,false]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(0,0%,88%)","line-opacity":0.9,"line-width":["interpolate",["exponential",1.55],["zoom"],13,1.8,20,20]}},{"id":"highway_major_casing","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":11,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["match",["get","class"],["primary","secondary","tertiary","trunk"],true,false]],"layout":{"line-cap":"butt","line-join":"miter"},"paint":{"line-color":"rgb(213, 213, 213)","line-dasharray":[12,0],"line-width":["interpolate",["exponential",1.3],["zoom"],10,3,20,23]}},{"id":"highway_major_inner","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":11,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["match",["get","class"],["primary","secondary","tertiary","trunk"],true,false]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#fff","line-width":["interpolate",["exponential",1.3],["zoom"],10,2,20,20]}},{"id":"highway_major_subtle","type":"line","source":"openmaptiles","source-layer":"transportation","maxzoom":11,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["match",["get","class"],["primary","secondary","tertiary","trunk"],true,false]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsla(0,0%,85%,0.69)","line-width":2}},{"id":"highway_motorway_casing","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["match",["get","brunnel"],["bridge","tunnel"],false,true],["==",["get","class"],"motorway"]]],"layout":{"line-cap":"butt","line-join":"miter"},"paint":{"line-color":"rgb(213, 213, 213)","line-dasharray":[2,0],"line-opacity":1,"line-width":["interpolate",["exponential",1.4],["zoom"],5.8,0,6,3,20,40]}},{"id":"highway_motorway_inner","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["match",["get","brunnel"],["bridge","tunnel"],false,true],["==",["get","class"],"motorway"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":["interpolate",["linear"],["zoom"],5.8,"hsla(0,0%,85%,0.53)",6,"#fff"],"line-width":["interpolate",["exponential",1.4],["zoom"],4,2,6,1.3,20,30]}},{"id":"highway_motorway_subtle","type":"line","source":"openmaptiles","source-layer":"transportation","maxzoom":6,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["==",["get","class"],"motorway"]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsla(0,0%,85%,0.53)","line-width":["interpolate",["exponential",1.4],["zoom"],4,2,6,1.3]}},{"id":"railway_transit","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["==",["get","class"],"transit"],["match",["get","brunnel"],["tunnel"],false,true]]],"layout":{"line-join":"round"},"paint":{"line-color":"#dddddd","line-width":3}},{"id":"railway_transit_dashline","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["==",["get","class"],"transit"],["match",["get","brunnel"],["tunnel"],false,true]]],"layout":{"line-join":"round"},"paint":{"line-color":"#fafafa","line-dasharray":[3,3],"line-width":2}},{"id":"railway_service","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["==",["get","class"],"rail"],["has","service"]]],"layout":{"line-join":"round"},"paint":{"line-color":"#dddddd","line-width":3}},{"id":"railway_service_dashline","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["==",["get","class"],"rail"],["has","service"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fafafa","line-dasharray":[3,3],"line-width":2}},{"id":"railway","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["!",["has","service"]],["==",["get","class"],"rail"]]],"layout":{"line-join":"round"},"paint":{"line-color":"#dddddd","line-width":["interpolate",["exponential",1.3],["zoom"],16,3,20,7]}},{"id":"railway_dashline","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["!",["has","service"]],["==",["get","class"],"rail"]]],"layout":{"line-join":"round"},"paint":{"line-color":"#fafafa","line-dasharray":[3,3],"line-width":["interpolate",["exponential",1.3],["zoom"],16,2,20,6]}},{"id":"highway_motorway_bridge_casing","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["==",["get","brunnel"],"bridge"],["==",["get","class"],"motorway"]]],"layout":{"line-cap":"butt","line-join":"miter"},"paint":{"line-color":"rgb(213, 213, 213)","line-dasharray":[2,0],"line-opacity":1,"line-width":["interpolate",["exponential",1.4],["zoom"],5.8,0,6,5,20,45]}},{"id":"highway_motorway_bridge_inner","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["match",["geometry-type"],["LineString","MultiLineString"],true,false],["all",["==",["get","brunnel"],"bridge"],["==",["get","class"],"motorway"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":["interpolate",["linear"],["zoom"],5.8,"hsla(0,0%,85%,0.53)",6,"#fff"],"line-width":["interpolate",["exponential",1.4],["zoom"],4,2,6,1.3,20,30]}},{"id":"boundary_3","type":"line","source":"openmaptiles","source-layer":"boundary","minzoom":8,"filter":["all",[">=",["get","admin_level"],3],["<=",["get","admin_level"],6],["!=",["get","maritime"],1],["!=",["get","disputed"],1],["!",["has","claimed_by"]]],"paint":{"line-color":"#bdc2b8","line-dasharray":[1,1],"line-width":["interpolate",["linear",1],["zoom"],7,1,11,2]}},{"id":"boundary_2","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["==",["get","admin_level"],2],["!=",["get","maritime"],1],["!=",["get","disputed"],1],["!",["has","claimed_by"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#a4aaa0","line-opacity":["interpolate",["linear"],["zoom"],0,0.4,4,1],"line-width":["interpolate",["linear"],["zoom"],3,1,5,1.2,12,3]}},{"id":"boundary_disputed","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["!=",["get","maritime"],1],["==",["get","disputed"],1]],"paint":{"line-color":"#a4aaa0","line-dasharray":[1,2],"line-width":["interpolate",["linear"],["zoom"],3,1,5,1.2,12,3]}},{"id":"label_city","type":"symbol","source":"openmaptiles","source-layer":"place","minzoom":3,"filter":["all",["all",["==",["get","class"],"city"],["!=",["get","capital"],2]],["<=",["coalesce",["get","rank"],99],6]],"layout":{"icon-allow-overlap":true,"icon-image":["step",["zoom"],"circle_11_black",9,""],"icon-optional":false,"icon-size":0.4,"text-anchor":"bottom","text-field":["coalesce",["get","name:nl"],["get","name:latin"],["get","name"]],"text-font":["Noto Sans Regular"],"text-max-width":8,"text-offset":[0,-0.1],"text-size":14,"text-allow-overlap":false},"paint":{"text-color":"#303d38","text-halo-blur":1,"text-halo-color":"#ffffff","text-halo-width":1.5,"text-opacity":1}},{"id":"label_city_capital","type":"symbol","source":"openmaptiles","source-layer":"place","minzoom":3,"filter":["all",["all",["==",["get","class"],"city"],["==",["get","capital"],2]],["<=",["coalesce",["get","rank"],99],6]],"layout":{"icon-allow-overlap":true,"icon-image":["step",["zoom"],"circle_11_black",9,""],"icon-optional":false,"icon-size":0.5,"text-anchor":"bottom","text-field":["coalesce",["get","name:nl"],["get","name:latin"],["get","name"]],"text-font":["Noto Sans Bold"],"text-max-width":8,"text-offset":[0,-0.2],"text-size":14,"text-allow-overlap":false},"paint":{"text-color":"#303d38","text-halo-blur":1,"text-halo-color":"#ffffff","text-halo-width":1.5,"text-opacity":1}},{"id":"label_country_3","type":"symbol","source":"openmaptiles","source-layer":"place","minzoom":2,"maxzoom":9,"filter":["all",["==",["get","class"],"country"],[">=",["get","rank"],3]],"layout":{"text-field":["coalesce",["get","name:nl"],["get","name:latin"],["get","name"]],"text-font":["Noto Sans Bold"],"text-max-width":6.25,"text-size":15,"text-allow-overlap":false},"paint":{"text-color":"#4b5350","text-halo-blur":1,"text-halo-color":"#ffffff","text-halo-width":1.5,"text-opacity":1}},{"id":"label_country_2","type":"symbol","source":"openmaptiles","source-layer":"place","maxzoom":9,"filter":["all",["==",["get","class"],"country"],["==",["get","rank"],2]],"layout":{"text-field":["coalesce",["get","name:nl"],["get","name:latin"],["get","name"]],"text-font":["Noto Sans Bold"],"text-max-width":6.25,"text-size":15,"text-allow-overlap":false},"paint":{"text-color":"#4b5350","text-halo-blur":1,"text-halo-color":"#ffffff","text-halo-width":1.5,"text-opacity":1}},{"id":"label_country_1","type":"symbol","source":"openmaptiles","source-layer":"place","maxzoom":9,"filter":["all",["==",["get","class"],"country"],["==",["get","rank"],1]],"layout":{"text-field":["coalesce",["get","name:nl"],["get","name:latin"],["get","name"]],"text-font":["Noto Sans Bold"],"text-max-width":6.25,"text-size":15,"text-allow-overlap":false},"paint":{"text-color":"#4b5350","text-halo-blur":1,"text-halo-color":"#ffffff","text-halo-width":1.5,"text-opacity":1}},{"id":"label_city_reference","type":"symbol","source":"pw-reference-cities","minzoom":3,"layout":{"icon-allow-overlap":true,"icon-image":["step",["zoom"],"circle_11_black",9,""],"icon-optional":true,"icon-size":0.4,"text-anchor":"bottom","text-field":["get","name"],"text-font":["Noto Sans Regular"],"text-max-width":8,"text-offset":[0,-0.1],"text-size":14,"text-allow-overlap":false},"paint":{"text-color":"#303d38","text-halo-blur":1,"text-halo-color":"#ffffff","text-halo-width":1.5,"text-opacity":1},"maxzoom":5}]};
      }

      syncVector() {
        if (!this.vectorMap || !this.isConnected) return;
        const bounds = this.mapViewport.getBoundingClientRect();
        const width = Math.round(bounds.width), height = Math.round(bounds.height);
        if (!width || !height) return;
        this.lastWidth = width; this.lastHeight = height;
        const geometry = this.geometry(width, height);
        const x = (geometry.left + width / 2) / geometry.world;
        const y = (geometry.top + height / 2) / geometry.world;
        this.vectorMap.resize();
        this.vectorMap.jumpTo({center: [x * 360 - 180, Math.atan(Math.sinh(Math.PI * (1 - 2 * y))) * 180 / Math.PI], zoom: Math.log2(geometry.world / 512), bearing: 0, pitch: 0});
        if (!this.vectorReady) return;
        this.mapViewport.setAttribute('data-ready', '');
        const loading = this.querySelector('[data-map-loading]');
        if (loading) loading.hidden = true;
        this.drawArea(geometry, width, height);
        this.mapMarkers.replaceChildren();
        this.drawMarkers(geometry, width, height);
      }

      async drawMap() {
        if (!this.isConnected || !this.area) return;
        if (this.vectorFailed) { this.drawRasterMap(); return; }
        if (this.vectorMap) { this.syncVector(); return; }
        if (this.vectorLoading) return;
        this.vectorLoading = true;
        const controller = this.controller;
        const fallback = () => {
          if (!this.isConnected || this.controller !== controller || controller.signal.aborted) return;
          clearTimeout(this.vectorTimer);
          const vector = this.vectorMap;
          this.vectorMap = null;
          vector?.remove();
          this.vectorFailed = true;
          this.dataset.mapRenderer = 'raster-fallback';
          const credit = this.querySelector('[data-vector-credit]');
          if (credit) credit.hidden = true;
          this.drawRasterMap();
        };
        try {
          const lib = await this.loadVectorLibrary();
          if (!this.isConnected || this.controller !== controller || controller.signal.aborted) return;
          this.mapTiles.replaceChildren();
          this.dataset.mapRenderer = 'vector';
          const map = new lib.Map({container: this.mapTiles, style: this.vectorStyle(), interactive: false, attributionControl: false, minZoom: -1, maxZoom: 20, renderWorldCopies: true, fadeDuration: 0, trackResize: false});
          this.vectorMap = map;
          this.syncVector();
          this.vectorTimer = setTimeout(fallback, 20000);
          map.on('load', () => {
            if (this.vectorMap !== map || this.controller !== controller) return;
            clearTimeout(this.vectorTimer);
            this.vectorReady = true;
            const credit = this.querySelector('[data-vector-credit]');
            if (credit) credit.hidden = false;
            this.syncVector();
          });
          map.on('error', () => { if (this.vectorMap === map && !this.vectorReady) fallback(); });
        } catch { fallback(); }
        finally { if (this.controller === controller) this.vectorLoading = false; }
      }

      drawRasterMap() {
        if (!this.isConnected || !this.area) return;
        const width = Math.round(this.mapViewport.getBoundingClientRect().width);
        const height = Math.round(this.mapViewport.getBoundingClientRect().height);
        if (!width || !height) return;
        this.lastWidth = width;
        this.lastHeight = height;
        this.generation = (this.generation || 0) + 1;
        const generation = this.generation;
        clearTimeout(this.mapTimer);
        this.mapShell.hidden = false;
        this.mapError.hidden = true;
        this.mapViewport.removeAttribute('data-ready');
        const loading = this.querySelector('[data-map-loading]');
        if (loading) loading.hidden = false;
        this.mapTiles.replaceChildren();
        this.mapMarkers.replaceChildren();
        if (this.mapAreaLayer) this.mapAreaLayer.setAttribute("hidden", "");
        const geometry = this.geometry(width, height);
        const total = 2 ** geometry.zoom;
        const tileSize = geometry.tileSize;
        const firstX = Math.floor(geometry.left / tileSize);
        const lastX = Math.floor((geometry.left + width - 1) / tileSize);
        const firstY = Math.floor(geometry.top / tileSize);
        const lastY = Math.floor((geometry.top + height - 1) / tileSize);
        const pending = [];
        for (let y = firstY; y <= lastY; y++) {
          if (y < 0 || y >= total) continue;
          for (let x = firstX; x <= lastX; x++) {
            const tile = new Image(256, 256);
            tile.alt = '';
            tile.decoding = 'async';
            tile.style.width = (tileSize + .5) + 'px';
            tile.style.height = (tileSize + .5) + 'px';
            tile.style.left = (x * tileSize - geometry.left) + 'px';
            tile.style.top = (y * tileSize - geometry.top) + 'px';
            const wrappedX = ((x % total) + total) % total;
            pending.push(new Promise((resolve, reject) => {
              tile.onload = resolve;
              tile.onerror = reject;
              tile.src = 'https://tile.openstreetmap.org/' + geometry.zoom + '/' + wrappedX + '/' + y + '.png';
            }));
            this.mapTiles.append(tile);
          }
        }
        const current = () => this.isConnected && generation === this.generation;
        const fail = () => {
          if (!current()) return;
          clearTimeout(this.mapTimer);
          this.generation++;
          this.mapShell.hidden = true;
          this.mapError.hidden = true;
          this.mapLink.hidden = true;
          if (this.mapPanel) this.mapPanel.hidden = true;
          this.restoreCountryFlag();
          this.mapTiles.replaceChildren();
          this.mapMarkers.replaceChildren();
          this.resize?.disconnect();
        };
        if (!pending.length) { fail(); return; }
        this.mapTimer = setTimeout(fail, 10000);
        Promise.all(pending).then(() => {
          if (!current()) return;
          clearTimeout(this.mapTimer);
          this.mapViewport.setAttribute('data-ready', '');
          if (loading) loading.hidden = true;
          this.drawArea(geometry, width, height);
          this.drawMarkers(geometry, width, height);
        }).catch(fail);
      }
    }
    customElements.define('pw-wine-specs-central-v5', PWWineSpecs);
  }

  } catch(e) { console.error(e); }
})();
})();
